<template>
  <div
    style="
      font-family: -apple-system-font, Helvetica Neue, Helvetica, STHeiTi,
        sans-serif;
    "
    class="normal"
    ref="homeWrapRef"
  >
    <el-carousel
      class="banner_carousel"
      height="755px !important"
      style="padding-top: 64px"
      :interval="5000"
    >
      <el-carousel-item v-for="(v, i) in bannerSourceList" :key="i">
        <el-image
          v-if="v.type === 'img'"
          @click="handleImgto(v.link)"
          :src="v.url"
          style="height: 755px; width: 100%; cursor: pointer"
        >
          <div slot="error" />
        </el-image>
        <video
          v-else-if="v.type === 'video'"
          id=""
          autoplay
          muted
          loop
          preload="auto"
          style="z-index: 200; height: 755px"
        >
          <source type="video/mp4" :src="v.url" />
        </video>
        <div class="bannerText" @click="handleImgto(v.link)">
          <div class="title">{{ v.title }}</div>
          <div class="text">{{ v.subTitle }}</div>
          <el-button
            class="button"
            style="border-radius: 0; margin-top: 40px"
            v-if="v.link != '' && v.title != ''"
          >
            <a :href="v.link" style="color: #fff"> 查看详情</a>
          </el-button>
        </div>
      </el-carousel-item>
    </el-carousel>

    <!--    平台增效-->
    <div class="ptzengxiao w-full-1440">
      <!-- <div style="font-size: 28px;color: #000;text-align: center;margin: 60px 0;">平台增效</div> -->
      <div class="box" style="height: 100%">
        <div
          class="area"
          style="
            background-image: url(../assets/images/bg_fwqy.png) no-repeat 100%;
          "
        >
          <div class="imgs" style="float: left; margin-top: 28px">
            <img
              src="../assets/images/ic_zxsy.png"
              alt=""
              style="width: 48px; height: 48px"
            />
          </div>
          <div class="number">
            <countTo
              :startVal="0"
              :endVal="count.effCount"
              :duration="2000"
            ></countTo>
          </div>
          <div class="text">增效收益(万元)</div>
        </div>
        <div class="area">
          <div class="imgs" style="float: left; margin-top: 28px">
            <img
              src="../assets/images/ic_jrsb.png"
              alt=""
              style="width: 48px; height: 48px"
            />
          </div>
          <div class="number">
            <countTo
              :startVal="0"
              :endVal="count.deviceCount"
              :duration="2000"
            ></countTo>
          </div>
          <div class="text">接入设备(台)</div>
        </div>
        <div class="area">
          <div class="imgs" style="float: left; margin-top: 28px">
            <img
              src="../assets/images/ic_fuqy.png"
              alt=""
              style="width: 48px; height: 48px"
            />
          </div>
          <div class="number">
            <countTo
              :startVal="0"
              :endVal="count.enterpriseCount"
              :duration="2000"
            ></countTo>
          </div>
          <div class="text">服务企业(家)</div>
        </div>
        <div class="area">
          <div class="imgs" style="float: left; margin-top: 28px">
            <img
              src="../assets/images/ic_kfz.png"
              alt=""
              style="width: 48px; height: 48px"
            />
          </div>
          <div class="number">
            <countTo
              :startVal="0"
              :endVal="count.developerCount"
              :duration="2000"
            ></countTo>
          </div>
          <div class="text">开发者(名)</div>
        </div>
      </div>
    </div>
    <main class="w-full-1440 normal">
      <div
        style="
          width: 100%;
          /* padding-bottom: 50px; */
          /* display: flex;
          justify-content: center; */
        "
      >
        <div style="height: 100%">
          <el-row>
            <el-col :span="24">
              <div
                style="
                  font-size: 30px;
                  color: #333;
                  text-align: center;
                  padding-top: 60px;
                  font-weight: 800;
                "
              >
                聚集环卫领域 精选产品服务
              </div>
            </el-col>
            <el-row
              :span="24"
              style="display: flex; width: 100%; justify-content: center"
            >
              <div
                style="
                  margin-top: 20px;
                  margin-right: 20px;

                  font-size: 14px;
                  font-weight: 400;
                  line-height: 16px;
                  letter-spacing: 0em;
                  text-align: center;
                  margin-bottom: 40px;
                "
              >
                多年技术沉淀，众多产品共筑E平台产品矩阵
              </div>
              <div
                style="
                  font-size: 10px;

                  font-size: 14px;
                  font-weight: 400;
                  line-height: 16px;
                  letter-spacing: 0em;
                  color: #d7000f;
                  text-align: center;
                  cursor: pointer;
                  margin: 20px 0;
                "
                @click="handleMoreDetails('/ProductService', 1)"
              >
                查看全部产品服务 >
              </div>
            </el-row>
          </el-row>

          <el-row
            class="contentall"
            type="flex"
            justify="space-between"
            :getter="10"
          >
            <el-col
              v-for="(item, index) in list"
              :key="index"
              style="text-align: center; cursor: pointer; width: 267px"
              class="tabItem"
            >
              <div @click="changeTypeActive(index)" style="width: 267px">
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    padding-bottom: 30px;
                  "
                >
                  <el-image
                    :scroll-container="homeWrap"
                    lazy
                    :src="item.icon"
                    style="width: 28px; height: 28px"
                  >
                    <div slot="error" />
                  </el-image>
                  <div
                    style="
                      color: #181818;
                      text-align: center;
                      font-size: 20px;
                      font-style: normal;
                      font-weight: 400;
                      line-height: 20px;
                    "
                  >
                    {{ item.dictLabel }}
                  </div>
                </div>
                <div
                  v-show="typeActive == index"
                  style="border-bottom: 4px solid red"
                >
                  <div style="width: 100%"></div>
                </div>
              </div>
            </el-col>
          </el-row>
          <div
            style="
              background-image: url(../../static/img/display-img/show_new/bg_bj.png);
            "
          >
            <div class="contentall">
              <el-row
                class="ellrow"
                style="width: 100%; padding: 40px 0 60px 0; height: 470px"
              >
                <el-col
                  :sm="12"
                  :md="6"
                  v-if="list.length"
                  style="
                    display: flex;
                    width: 299px;
                    padding: 16px;
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 16px;
                  "
                >
                  <div
                    v-for="(item, index) in list[typeActive].serviceList
                      .length > 3
                      ? list[typeActive].serviceList.slice(0, 2)
                      : list[typeActive].serviceList.slice(0, 1)"
                    :key="item.id"
                    class="star-label"
                    @click="handelProductDetails(item)"
                  >
                    <div class="label-title">{{ item.productTitle }}</div>
                    <div class="label-desc" style="line-height: 15px">
                      {{ item.productIntroduction }}
                    </div>
                    <div
                      style="
                        margin-top: 10px;
                        display: flex;
                        align-items: center;
                        gap: var(---8, 8px);
                        align-self: stretch;
                      "
                    >
                      <div
                        style="background: #e50009; color: #fff"
                        class="laber-btn"
                        @click="handelProductDetails(item)"
                      >
                        查看详情
                      </div>
                      <div
                        class="laber-btn"
                        style="color: #333333; border: 1px solid #999999"
                        @click="handelConsultClick(item)"
                      >
                        立即咨询
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :sm="24" :md="18">
                  <el-row v-if="list.length">
                    <el-col
                      :xs="12"
                      :sm="12"
                      :md="8"
                      style="
                        width: 320px;
                        height: 124px;
                        padding: 20px 16px 16px 16px;
                      "
                      v-for="(item, index) in list[typeActive].serviceList
                        .length > 3
                        ? list[typeActive].serviceList.slice(2)
                        : list[typeActive].serviceList.slice(1)"
                      :key="item.id"
                      v-if="index < 9"
                    >
                      <div
                        class="general-label"
                        @click="handelProductDetails(item)"
                      >
                        <div class="label-title">
                          {{ item.productTitle }}
                          <span
                            style="
                              height: 22px;
                              width: 22px;
                              display: inline-block;
                              text-align: center;
                              border-radius: 4px;
                              line-height: 22px;
                              background: #d7000f33;
                              color: #d7000f;
                              font-weight: 400;
                              font-size: 12px;
                            "
                            v-if="item.categoryLabel == '热门产品'"
                          >
                            热</span
                          >
                          <span
                            style="
                              height: 22px;
                              width: 22px;
                              display: inline-block;
                              text-align: center;
                              border-radius: 4px;
                              line-height: 22px;
                              background: #d7000f33;
                              color: #d7000f;
                              font-weight: 400;
                              font-size: 12px;
                            "
                            v-if="item.categoryLabel == '免费产品'"
                          >
                            免</span
                          >
                        </div>
                        <div class="label-desc" style="width: 90%">
                          {{ item.productIntroduction }}
                        </div>
                        <div v-if="item.starLabel" style="display: flex">
                          <div
                            v-for="(i, a) in item.starLabel"
                            :key="i"
                            style="
                              width: 70px;
                              height: 25px;
                              line-height: 25px;
                              margin-right: 5px;
                              text-align: center;
                              color: #999999;
                              border: 1px solid #999999;
                            "
                          >
                            <div v-if="a < 3">{{ i }}</div>
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>

      <!-- 解决方案 -->
      <div class="jxfa" style="height: 688px">
        <img src="../assets/images/bg_jjfa.png" alt="" />
        <div class="contentall">
          <el-row style="width: 100%">
            <el-col :span="24">
              <div
                style="
                  font-size: 30px;
                  color: #fff;
                  text-align: center;
                  font-weight: 800;
                "
              >
                E平台解决方案 助力环境行业数字化转型
              </div>
            </el-col>
            <el-row
              :span="24"
              style="display: flex; width: 100%; justify-content: center"
            >
              <div
                style="
                  margin-top: 20px;
                  margin-right: 20px;

                  font-size: 14px;
                  font-weight: 400;
                  line-height: 16px;
                  letter-spacing: 0em;
                  margin-bottom: 40px;
                  text-align: center;
                  color: #ffffffcc;
                "
              >
                面向丰富的业务场景，提供整套行业和技术解决方案
              </div>
              <div
                style="
                  font-size: 10px;

                  font-size: 14px;
                  font-weight: 400;
                  line-height: 16px;
                  letter-spacing: 0em;
                  color: #d7000f;
                  text-align: center;
                  cursor: pointer;
                  margin: 20px 0;
                "
                @click="handleMoreDetails('/Solution', 1)"
              >
                查看全部解决方案 >
              </div>
            </el-row>
          </el-row>
          <el-row
            :gutter="20"
            style="flex-wrap: wrap; width: 100%; height: 450px"
          >
            <!-- <el-col :xs="24" :md="12" style="margin-bottom: 20px;" v-for="(item, index) in solutionList" :key="item.id">
              <div style="position: relative;display: flex; justify-content: center;align-items: center;"
                class="solution">
                <div class="solution-mask"></div>
                <el-image :scroll-container="homeWrap" lazy fit="fill" :src="item.schemeCover" v-if="item.schemeCover">
                  <div slot="error" />
                </el-image>
                <div class="solution-card" @click="toSolution(item)">
                  <el-row :gutter="20">
                    <el-col :span="4">
                      <el-image :scroll-container="homeWrap" lazy :src="index < 4 ? solutionIcon[index] : solutionIcon[1]"
                        style="width: 100%; ">
                        <div slot="error" />
                      </el-image>
                    </el-col>
                    <el-col :span="20">
                      <div style="color: #fff;font-size: 0.2rem;font-weight: 600;margin-bottom: 5px;">{{
        item.solutionTitle
      }}
                      </div>
                      <div style="color: #fff;font-size: 0.14rem;font-weight: 600;opacity: 0.7;margin-bottom: 5px;">{{
          item.schemeIntroduction
        }}</div>
                      <el-button v-if="$store.state.app.device == 'desktop'" size="mini"
                        style="font-size: 14px;opacity: 0.7;margin-top: 10px;">查看方案</el-button>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-col> -->

            <div
              style="
                display: flex;
                justify-content: center;
                /* margin-top: 20px; */
                padding-bottom: 50px;
              "
            >
              <div
                style="
                  width: 380px;
                  position: relative;
                  left: 30px;
                  z-index: 201;
                "
              >
                <img
                  src="../assets/images/bg_jjfa_le.png"
                  alt=""
                  style="width: 100%"
                />
              </div>
              <div style="width: 900px">
                <el-carousel height="470px" style="" :interval="5000">
                  <el-carousel-item
                    v-for="(v, i) in solutionList"
                    :key="i"
                    style="cursor: pointer"
                  >
                    <el-image
                      :src="v.url"
                      style="height: 470px; width: 100%"
                      @click="toSolution(v)"
                    >
                      <div slot="error" />
                    </el-image>
                    <div class="bannerText_other" @click="toSolution(v)">
                      <div class="title">{{ v.title }}</div>
                      <div class="text">{{ v.remakes }}</div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </el-row>
        </div>
      </div>

      <!-- 案例精选 -->
      <div style="width: 100%; margin-top: 60px">
        <div>
          <el-row>
            <el-col :span="24">
              <div
                style="
                  font-size: 30px;
                  color: #333;
                  text-align: center;
                  font-weight: 800;
                "
              >
                企业成功案例
              </div>
            </el-col>
            <el-row
              :span="24"
              style="display: flex; width: 100%; justify-content: center"
            >
              <div
                style="
                  margin-top: 20px;
                  margin-right: 20px;

                  font-size: 14px;
                  font-weight: 400;
                  line-height: 16px;
                  letter-spacing: 0em;
                  text-align: center;
                  color: #999999;
                  margin-bottom: 40px;
                "
              >
                企业的最佳实践，值得选择
              </div>
              <div
                style="
                  font-size: 10px;

                  font-size: 14px;
                  font-weight: 400;
                  line-height: 16px;
                  letter-spacing: 0em;
                  color: #d7000f;
                  text-align: center;
                  cursor: pointer;
                  margin: 20px 0;
                "
                @click="handleMoreDetails('/TypicalCase', 1)"
              >
                查看全部典型案例 >
              </div>
            </el-row>
          </el-row>
          <el-row>
            <!-- <el-col v-for="(item, index) in
            caseList" :key="index" :sm="12" :md="6" style="margin-bottom: 20px">
              <el-card :body-style="{ padding: '0px' }" class="evenflow_scale">
                <div @click="handleCaseDetails(item)">
                  <el-image :scroll-container="homeWrap" lazy :src="item.caseCover" style="width: 100%;height: 200px">
                    <div slot="error" />
                  </el-image>
                  <div style="padding: 14px;height: 180px;">
                    <div class="hidden-1" style="font-size: 20px;font-weight: 600;line-height: 60px;">{{
        item.caseTitle
      }}
                    </div>
                    <div class="hidden-4" style="font-size: 16px;line-height: 30px;">{{ item.caseContent }}</div>
                  </div>
                </div>
              </el-card>
            </el-col> -->
            <div
              style="
                position: relative;
                width: 100%;
                display: flex;
                align-items: flex-start;
              "
            >
              <div
                @click="goTypicalCase()"
                :style="{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-end',
                  width: '50%',
                  height: '500px',
                  position: 'relative',
                  background: `url(${caseImg})`,
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                }"
              >
                <!--<img :src="caseImg" alt="" style="width: 100%;">-->
                <div class="qyigol_img_cover">
                  <div
                    v-for="(item, index) in caseList"
                    :key="index"
                    style="
                      margin-left: 10px;
                      cursor: pointer;
                      transform: skewX(-8deg);
                    "
                    @click.stop="tabClick(item)"
                  >
                    <div
                      v-if="index < 3"
                      style="
                        width: 250px;
                        height: 44px;
                        text-align: center;
                        line-height: 44px;
                        border-radius: 4px;
                      "
                      :style="
                        caseImg === item.caseCover
                          ? 'background: #fff;color:#D7000F ;font-weight:800;'
                          : 'background:#333;color:#FFFFFF;'
                      "
                    >
                      <div style="transform: skewX(8deg)">
                        {{ item.caseTitle }}
                      </div>
                    </div>
                  </div>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="70"
                  height="500"
                  viewBox="0 0 70 500"
                  fill="none"
                  style="position: absolute; right: -1px"
                >
                  <path d="M70 0V500H0L70 0Z" fill="#D7000F" />
                </svg>
              </div>

              <div
                style="
                  width: 50%;
                  height: 500px;
                  background: #d7000f;
                  padding: 100px;
                "
              >
                <div style="width: 540px">
                  <div style="margin-left: 40px">
                    <img
                      src="../assets/images/bg_yin_l.png"
                      alt=""
                      style="width: 75px"
                    />
                  </div>
                  <div
                    style="
                      height: 180px;
                      width: 460px;
                      margin: 30px 80px;

                      font-size: 16px;
                      font-weight: 400;
                      line-height: 36px;
                      letter-spacing: 0em;
                      text-align: left;
                      color: #ffffff;
                    "
                  >
                    {{ caseText }}
                  </div>
                  <div style="text-align: right">
                    <img
                      src="../assets/images/bg_yin_r.png"
                      alt=""
                      style="width: 75px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </el-row>
        </div>
      </div>
      <!-- 直播 -->
      <div class="live-box">
        <!-- <img
                src="../assets/images/livebackground/backimg.png"
                alt=""
                style="width: 100%; height: 100%"
              /> -->
        <div style="width: 100%">
          <el-row>
            <el-col :span="24">
              <div
                style="
                  color: #333;
                  padding-top: 60px;

                  font-size: 30px;
                  font-weight: 800;
                  line-height: 30px;
                  text-align: center;
                "
              >
                博士侃环境
              </div>
            </el-col>
            <el-row
              :span="24"
              style="display: flex; width: 100%; justify-content: center"
            >
              <div
                style="
                  margin-top: 20px;
                  margin-right: 20px;

                  font-size: 14px;
                  font-weight: 400;
                  line-height: 16px;
                  letter-spacing: 0em;
                  text-align: center;
                  color: #999999;
                  margin-bottom: 30px;
                "
              >
                聚集环境大咖，分享专业知识
              </div>
              <div
                style="
                  font-size: 10px;

                  font-size: 14px;
                  font-weight: 400;
                  line-height: 16px;
                  letter-spacing: 0em;
                  color: #d7000f;
                  text-align: center;
                  cursor: pointer;
                  margin: 20px 0;
                "
                @click="allLiveReplay"
              >
                查看全部
              </div>
            </el-row>
          </el-row>
          <el-row :gutter="40">
            <div
              style="
                width: 100%;
                height: 430px;
                display: flex;
                justify-content: center;
              "
              class="w-full-1440"
            >
              <!-- <img
                src="../assets/images/bg_ptzx_nei.png"
                alt=""
                style="width: 100%; height: 100%"
              /> -->
              <!-- <div
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  display: flex;
                  flex-direction: row-reverse;
                  width: 100%;
                  height: 100%;
                "
              > -->
              <div
                @click="playbackDetail('58')"
                style="
                  cursor: pointer;
                  width: 632px;
                  height: 428px;
                  border-radius: 4px;
                  border: 2px solid #fff;
                  box-shadow: -18px -11px 20px 0px #ffffff;
                  box-shadow: -3px 8px 20px 0px #3763aa1a;
                "
              >
                <img
                  src="../assets/images/livebackground/zhsy-1126.jpg"
                  alt=""
                  style="
                    width: 100%;
                    height: 302px;
                    object-fit: cover;
                    box-shadow: 0px 8px 16px 0px #60617029;
                    box-shadow: 0px 2px 4px 0px #28293d0a;
                  "
                />
                <div
                  class="pointer"
                  style="
                    width: 100%;
                    height: 120px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                  "
                >
                  <!-- <div style="padding: 4px 10px;">
                        <div class="livePreview">直播预告</div>
                        <p style="font-size: 12px;font-weight: bold;color: #fff;">直播时间：2024.07.29 16:30</p>
                      </div> -->

                  <div class="liveyugaotitle">
                    <div style="font-size: 20px; font-weight: 600; color: #333">
                      环境行业先锋榜》之智能产品微论坛（一）智慧收运系统产品介绍
                    </div>
                    <div class="jianjie">
                      简介：环境行业先锋榜》之智能产品微论坛（一）智慧收运系统产品介绍
                    </div>
                    <div
                      style="
                        font-size: 16px;
                        font-weight: 400;

                        color: #666666;
                      "
                    >
                      直播时间：2024.11.26 16:30
                    </div>
                  </div>
                </div>
              </div>
              <div
                style="
                  width: 632px;
                  height: 428px;
                  margin-left: 20px;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                "
              >
                <div
                  style="
                    display: flex;
                    width: 100%;
                    height: 132px;
                    cursor: pointer;
                  "
                  @click="playbackDetail('59')"
                >
                  <div style="margin-right: 10px; position: relative">
                    <img
                      class="liveimg"
                      src="../assets/images/livebackground/zhsy-1126.jpg"
                      alt=""
                    />
                    <span class="huifang">回放</span>
                  </div>
                  <div class="live-label">
                    <div class="liveTitle">《环境行业先锋榜》之智能产品微论坛（二）智慧安环系统产品介绍</div>
                    <div class="liveTime">
                      《环境行业先锋榜》之智能产品微论坛（二）智慧安环系统产品介绍
                    </div>
                  </div>
                </div>
                <div
                  style="
                    display: flex;
                    width: 100%;
                    height: 132px;
                    margin-top: 10px;
                    margin-bottom: 10px;
                    cursor: pointer;
                  "
                  @click="playbackDetail('60')"
                >
                  <div style="margin-right: 10px; position: relative">
                    <img
                      src="../assets/images/livebackground/zhsy-1126.jpg"
                      alt=""
                      class="liveimg"
                    />
                    <span class="huifang">回放</span>
                  </div>
                  <div class="live-label">
                    <div class="liveTitle">
                      《环境行业先锋榜》之智能产品微论坛（三）智慧厕改系统产品介绍
                    </div>
                    <div class="liveTime">
                      《环境行业先锋榜》之智能产品微论坛（三）智慧厕改系统产品介绍
                    </div>
                  </div>
                </div>
                <div
                  style="
                    display: flex;
                    width: 100%;
                    height: 132px;
                    cursor: pointer;
                  "
                  @click="playbackDetail('61')"
                >
                  <div style="margin-right: 10px; position: relative">
                    <img
                      src="../assets/images/livebackground/zhsy-1126.jpg"
                      alt=""
                      class="liveimg"
                    />
                    <span class="huifang">回放</span>
                  </div>
                  <div class="live-label">
                    <div class="liveTitle">
                      《环境行业先锋榜》之智能产品微论坛（四）互动问答环节及产品总结
                    </div>
                    <div class="liveTime">
                      《环境行业先锋榜》之智能产品微论坛（四）互动问答环节及产品总结
                    </div>
                  </div>
                </div>
              </div>

              <!-- </div> -->
            </div>
          </el-row>
        </div>
      </div>

      <!-- 共建新生态的合作伙伴 -->
      <div style="height: 860px; display: flex; justify-content: center">
        <div style="width: 100%; text-align: center" class="contentall">
          <div
            style="
              font-size: 30px;
              text-align: center;
              padding-top: 60px;
              font-weight: 800;
              color:#333;
            "
          >
            共建新生态的合作伙伴
          </div>
          <el-row
            :span="24"
            style="display: flex; width: 100%; justify-content: center"
            class="contentall"
          >
            <div
              style="
                margin-top: 20px;
                margin-right: 20px;

                font-size: 14px;
                font-weight: 400;
                line-height: 16px;
                letter-spacing: 0em;
                text-align: center;
                padding-bottom: 40px;
                color: #999999;
              "
            >
              开放的生态环境，多方合作伙伴支持，生态共建，价值共赢
            </div>
          </el-row>
          <div>
            <div style="position: relative" class="w-full">
              <div
                style="
                  position: absolute;
                  text-align: center;
                  margin-left: -640px;
                  left: 50%;
                "
                class="contentall"
              >
                <!-- <div id="container" ref="content"></div> -->
                <iframe
                  src="/static/earth/index.html"
                  style="width: 1920px; height: 1080px; border: none"
                ></iframe>
              </div>
              <div
                class="contentall"
                style="
                  position: absolute;
                  z-index: 1001;
                  margin-left: -640px;
                  left: 50%;
                  top: 100px;
                  width: 640px;
                "
              >
                <div
                  style="
                    font-size: 26px;
                    font-weight: 600;
                    line-height: 28.5px;
                    text-align: left;
                    color: #252b3a;
                    margin-bottom: 16px;
                  "
                >
                  E平台生态共建共推模式
                </div>
                <div
                  style="
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 28px;
                    text-align: left;
                    margin-bottom: 20px;
                    color: #666666;
                  "
                >
                  以我国环境行业升级发展为己任，本着优势互补、共同发展的原则，经友好协商，作为环境产业互联网平台建设、运营、推广的生态合作伙伴，达成战略合作共识。
                </div>
                <div
                  style="
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 28px;
                    text-align: left;
                    color: #666666;
                    margin-bottom: 16px;
                  "
                >
                  合作以用户价值共创、共享为原则，以分增效的方式运行。分增效是从经营本质和商业逻辑利他的原点出发，抓住工业互联网增效核心和建设特点，整合各细小颗粒最专业的人员，深入挖掘资源和系统潜能，创造新价值，共享增效。
                </div>
                <div
                  style="
                    font-size: 10px;

                    font-size: 15px;
                    font-weight: 400;
                    line-height: 16px;
                    letter-spacing: 0em;
                    color: #d7000f;
                    text-align: left;
                    cursor: pointer;
                    margin: 20px 0;
                  "
                  @click="handleMoreDetails('/EcoPartner', 1)"
                >
                  了解共建共推
                </div>
              </div>
              <div
                style="
                  position: absolute;
                  z-index: 1001;
                  width: 100%;
                  height: 300px;
                  top: 385px;
                  background-color: #fff;
                "
              >
                <vue-seamless-scroll
                  v-for="(customerListRow, index) in customerList"
                  :key="index"
                  :data="customerListRow"
                  :class-option="classOption[index]"
                  style="
                    background: #fff;
                    width: 100%;
                    height: 80px;
                    margin-bottom: 12px;
                    overflow: hidden;
                  "
                >
                  <ul
                    class="item"
                    style="display: flex; margin: 0 auto; padding: 0"
                  >
                    <div
                      class="item-boxs"
                      v-for="(item,i) in customerListRow"
                      :key="i"
                    >
                      <img
                        :scroll-container="homeWrap"
                        :src="item.unitLogo"
                        style="width: 100%; height: 100%"
                        class="scrollImage"
                      />
                    </div>
                  </ul>
                </vue-seamless-scroll>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 平台咨询 -->
      <div style="width: 100%">
        <div
          style="position: relative; width: 100%; height: 660px"
          class="grid-hero"
        >
          <img
            src="../assets/images/bg_ptzx.png"
            alt=""
            style="width: 100%; height: 700px"
          />
          <el-row class="w-full contentall">
            <el-col :span="24">
              <div
                style="
                  font-size: 30px;
                  color: #333;
                  text-align: center;
                  padding-top: 60px;
                  font-weight: 800;
                "
              >
                平台资讯
              </div>
            </el-col>
            <el-row
              :span="24"
              style="display: flex; width: 100%; justify-content: center"
            >
              <div
                style="
                  margin-top: 20px;
                  margin-right: 20px;

                  font-size: 14px;
                  font-weight: 400;
                  line-height: 16px;
                  letter-spacing: 0em;
                  text-align: center;
                  color: #999999;
                  padding-bottom: 40px;
                "
              >
                平台相关动向，行业资讯
              </div>
              <div
                style="
                  font-size: 10px;

                  font-size: 14px;
                  font-weight: 400;
                  line-height: 16px;
                  letter-spacing: 0em;
                  color: #d7000f;
                  text-align: center;
                  cursor: pointer;
                  margin: 20px 0;
                "
                @click="handleMoreDetails('/Information', 1)"
              >
                全部资讯 >
              </div>
            </el-row>
            <div style="height: 462px; position: relative" class="w-full">
              <img
                src="../assets/images/bg_ptzx_nei.png"
                alt=""
                style="width: 100%; height: 480px"
              />
              <div
                style="
                  position: absolute;
                  top: 8px;
                  transform: translateX(-50%);
                  left: 50%;
                  display: flex;
                "
              >
                <div>
                  <div
                    v-for="(item, index) in consultationList"
                    :key="item.id"
                    @click="goConsuleDetail(item)"
                    class="ptImage-left"
                  >
                    <div v-if="index < 2" class="ptImage_other">
                      <div class="ptImage_other-label">
                        <img
                          :src="item.thumbnail"
                          alt=""
                          style="
                            width: 590px;
                            height: 180px;
                            transition: all 0.6s;
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    class="ptImage_right"
                    v-for="(item, index) in consultationList"
                    :key="item.id"
                    style="width: 560px"
                    @click="goConsuleDetail(item)"
                  >
                    <div v-if="index > 1 && index < 5">
                      <div
                        style="
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                        "
                        class="ptHover"
                      >
                        <div
                          style="
                            margin-right: 20px;
                            width: 240px;
                            overflow: hidden;
                          "
                          class="ptImage"
                        >
                          <img
                            :src="item.thumbnail"
                            alt=""
                            style="height: 114px; width: 100%; margin: 0 auto"
                          />
                        </div>
                        <div
                          class="ptHover-label"
                          style="overflow: hidden; width: 390px"
                        >
                          <div class="ptTitle">{{ item.title }}</div>
                          <div class="ptContent">
                            {{ item.riefIntroduction }}
                          </div>
                          <div class="ptTime">{{ item.createTime }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-row>
        </div>
      </div>
      <!-- 社会责任与能力 -->
      <div style="width: 100%">
        <div
          style="position: relative; width: 100%; height: 643px"
          class="grid-hero"
        >
          <img
            src="../assets/images/bg_shehuizeren.png"
            alt=""
            style="width: 100%"
          />
          <el-row style="" class="w-full">
            <el-col :span="24">
              <div
                style="
                  font-size: 30px;
                  color: #333;
                  text-align: center;
                  padding-top: 60px;
                  font-weight: 800;
                "
                class="w-full text-center contentall"
              >
                社会责任与能力
              </div>
            </el-col>
            <el-row
              :span="24"
              style="display: flex; justify-content: center"
              class="contentall"
            >
              <div
                style="
                  margin-top: 22px;
                  margin-right: 20px;

                  font-size: 14px;
                  font-weight: 400;
                  line-height: 16px;
                  letter-spacing: 0em;
                  text-align: center;
                  color: #999999;
                  margin-bottom: 40px;
                "
              >
                企业的最佳实践，值得选择
              </div>
            </el-row>
            <div style="height: 462px; position: relative" class="contentall">
              <div style="position: absolute; top: 0">
                <!-- <svg
                  t="1722559367353"
                  class="icon"
                  width="633"
                  height="131"
                  viewBox="0 0 4955 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="805"
                >
                  <path
                    d="M88.110901 72.930687l2.055817 39.709313H66.935206L53.693557 72.930687h34.417344z m148.519084 77.933435l-2.642077 28.828336H184.867176l-13.523054 127.054168h55.874443l-2.939115 27.937221H79.872l2.649893-27.937221h58.524336l13.523053-127.054168H106.93374l2.642077-28.828336h47.643359l8.2389-77.933435h30.290077L187.524885 150.864122h49.112917z m-132.643176-27.350962l-2.939114 26.467664-43.820947 51.473588h16.469985L58.696305 344.681527H29.578748l13.233832-126.460092-6.464488 7.644825H8.700092l56.75774-75.877619h-40.881832l2.946931-26.475481h76.463878z m1.469557 77.933435l3.236153 65.004458h-19.698321l-10.591755-64.996641h27.06174zM412.101374 72.930687L492.379847 155.86687l-2.939114 27.358779L387.400305 94.981863 266.224366 183.217832l2.939115-27.350962L366.513832 72.930687h45.587542zM312.687389 185.867725l2.946932-28.234259H445.322748l-2.642076 28.234259h-129.993283z m-6.761526 56.757741H264.754809l3.228336-27.937222H481.514504l-3.236153 27.937222h-139.998778l-35.285008 69.116091h125.287572l-13.523053-47.643359h31.173374l17.939542 76.463878H259.752061l46.173802-97.93661z m419.871267-88.228153H646.97258l-2.345038 17.353282h96.459237l-2.345039 25.873588H515.501924l2.649893-25.873588h96.459236l2.063634-17.353282H537.568733l2.055817-22.94229h79.113771l1.766595-16.469985H531.682687l2.649893-26.467664h89.111451l1.766595-15.883725h30.297893l-1.766595 15.883725h88.822229l-2.65771 26.467664h-89.111451l-1.758778 16.469985h79.105954l-2.345038 22.94229z m-8.528122 59.118412l-8.528123 81.466626h-29.703816l5.581191-55.593038H559.916947l-5.589008 55.593038h-29.406779l8.528122-81.474443H717.269008z m-111.17826 35.582046h30.297893l-2.352855 25.592183 87.352672 70.288611h-31.76745l-73.821802-44.407206-82.639145 44.399389h-31.76745l102.056061-69.991572 2.642076-25.873588zM820.685191 72.633649h33.823267l-49.706992 74.705099h20.292397l-20.878657 197.929038h-29.414595l18.830656-181.169832-5.002748 7.652641h-23.239328l55.296-99.116946z m172.64171 6.175267l-2.939115 28.531298-54.70974 9.114381-7.347786 70.296428h60.587969l-2.946931 28.531298h-60.580153l-9.708458 91.456488h54.998962l-2.939115 28.242076h-140.882076l2.939115-28.234259h55.593038l9.41142-91.472122h-60.885008l2.939114-28.531298h61.174229l7.355603-70.288611h-54.412702l3.236153-28.820519h84.702778l54.412703-8.82516z"
                    fill="#D7000F"
                    p-id="806"
                  ></path>
                  <path
                    d="M82.232672 581.19426l-1.250687 11.756458H30.079023l-3.626992 34.393893h45.024732l-1.250687 11.756458h-45.024732l-3.87713 37.52061h52.403786l-4.252336 11.63139H7.816794l5.127817-49.152 1.250687-11.756458 3.626992-34.393893 1.250687-11.756458h63.159695z m30.047755 12.256732h-12.256732l1.250687-12.256732h12.256733l-1.250688 12.256732z m-10.005496 94.802077h-12.256733l8.379604-79.04342h12.256732l-8.379603 79.04342z m42.859481-94.802077h-12.256733l1.250687-12.256732h12.256733l-1.250687 12.256732z m-10.005496 94.802077h-12.256733l8.379603-79.04342h12.256733l-8.379603 79.04342z m90.127634-79.293558l-7.621374 71.789436-0.625344 6.878778h-46.650626l-2.87658 28.140458h-12.256733l2.87658-28.140458 1.250687-11.631389 7.003848-67.036825h58.907358z m-13.499603 11.63139h-34.393894l-5.75316 55.405435h34.393893l5.753161-55.405435z m44.555725-39.396641L246.307176 676.621679h11.373435l-4.252336 11.63139h-20.636336l11.256183-107.058809h12.256733z m25.295145 39.646778l-1.750962-11.631389h58.78229l-8.254534 79.04342h-57.406535l5.127817-48.401588h45.149802l2.001099-19.010443h-43.648977z m7.504122 30.641832l-2.626443 25.013741h32.893069l2.626443-25.013741h-32.893069z m103.549069-42.273221l-1.250687 11.631389h-17.642504l-5.753161 55.780641h15.14113l-4.260152 11.63139h-24.388397l7.011664-67.412031h-15.14113l1.250687-11.631389h15.133313l1.750962-16.509069h12.264549l-1.750961 16.509069h17.634687z m101.704305 81.294656H399.438168l1.250687-12.256732h67.036824l3.001649-16.759207h-59.782839l15.008244-69.663267h-13.632489l1.375756-12.131664H503.245191l-1.250687 12.131664h-63.534901l-3.626992 16.759206H493.239695l-13.007145 69.663268h15.258381l-1.125618 12.256732z m-62.034076-69.788336l-6.128367 28.640733h46.775695l5.127817-28.640733h-45.775145z m175.674626-30.016488l-1.375756 11.756458h-18.635237l-2.376305 24.263328h20.636336l-1.375756 11.756458h-19.885924l15.133313 54.279817h-10.380702l-13.257282-37.645679-20.886474 37.645679h-10.255633l26.389496-54.279817h-20.136061l1.375756-11.756458h20.511267l2.501374-24.263328h-18.510168l1.375756-11.756458h8.504671l-4.002198-14.132763h13.382351l1.00055 14.132763h11.381252l3.752061-14.132763h13.382351l-6.878779 14.132763h8.629741z m-62.534352 67.787237l6.503573-1.250687-1.125618 11.756458-6.503573 1.250687-2.376305 22.262229h-10.63084l2.251237-19.885924-26.514565 5.503023 1.250687-12.006596 3.752061-0.750412 7.754259-74.415878h-3.501923l1.125618-11.131114h40.897466l-1.375756 11.131114h-4.377405l-7.128916 67.5371zM528.962443 606.583206h11.50632l1.375756-15.633588h-11.256183l-1.625893 15.633588z m-2.87658 26.639634h11.381252l1.625893-16.008794h-11.256184l-1.750961 16.008794z m-3.126718 29.766351l11.631389-2.251237 1.876031-16.759206h-11.381252l-2.126168 19.010443z m90.752977 29.391145l11.756458-112.686901H716.018321l-11.756458 112.686901h-18.510168l-1.876031-11.881527h9.63029l9.130015-88.423572h-66.41148l-10.380703 100.305099h-12.131664z m43.023634-93.926596h10.755908l-13.257282 37.020336 5.002748 41.022535h-8.754809l-3.251787-21.511817-7.62919 21.511817h-8.879878l13.632488-41.022535-5.503023-37.020336h10.880977l1.876031 15.383451 5.127817-15.383451z m28.765801 36.895268l5.127817 41.147603H681.624427l-3.251786-21.386748-7.629191 21.386748h-8.879877l13.632488-41.022535-5.503023-37.020336h10.880977l1.876031 15.258382L687.877863 598.45374h10.880977l-13.257283 36.895268z m86.250504 57.156397h-13.132214l4.002199-40.021985h-40.647328l1.375755-12.631939h40.647329l5.127816-47.776244H732.35542l1.375756-12.381802h86.547542l-1.125619 12.381802h-36.64513l-5.252885 47.776244h40.897466l-1.375756 12.631939h-40.647328l-4.377405 40.021985z m-20.511267-61.158596h-9.880428l-6.503572-30.641832h14.382901l2.001099 30.641832z m50.027481 0h-9.880428l9.130016-30.641832h14.3829l-13.632488 30.641832z m122.262473-8.004397h-89.549191l26.01429-46.400488h14.758107l-20.386198 33.893618h51.903511l-8.004397-21.511817h14.257832l11.006046 34.018687z m-11.381252 67.286962h-80.669313l5.628092-54.529954h80.794381l-5.75316 54.529954z m-63.409832-42.148153l-3.126717 29.766352h55.030229l3.251786-29.766352h-55.155298z m109.638351-71.789435h13.257283l-19.010443 32.017588h9.380153l-8.75481 84.171237h-12.131664l8.004397-78.293008-2.501374 4.252336h-10.630839l22.387297-42.148153z m77.16739 11.256183l-1.250687 12.131665h-37.020336l-2.0011 19.510717h33.268275l-1.250687 12.256733h-33.393343l-2.126168 19.510718h34.393893l-1.250687 12.131664h-34.393893l-2.87658 29.391145h-12.131665l10.255634-99.804825-13.257282 30.266626h-8.629741l15.883725-46.650626h13.132214l-4.877679 11.256183h47.526107z m64.238412-11.131114l-9.505222 21.636885h47.901313l-9.880427 94.301802h-20.386199l-1.87603-12.006595h10.255633l7.379054-70.288611h-38.646229l-36.144855 82.295206h-11.506321l32.893069-82.295206h-22.887572l1.375755-12.006596h11.381252l-4.502473-17.884824h13.257282l1.125619 17.884824h5.127816l8.629741-21.636885h16.008794z m-9.130015 52.528855h14.132763l2.87658 28.015389h-9.380153l-7.62919-28.015389z m83.624061-52.528855h14.758106l-25.388946 27.390046h-10.63084l21.26168-27.390046z m19.885923 6.003298h51.528306l-1.125619 12.256732h-51.653374l1.250687-12.256732z m-23.512916 23.512916h15.258382l-20.636336 21.761954h9.004947l-6.75371 64.53545h-12.381802l6.378504-60.408183-1.876031 1.876031h-11.131114l22.13716-27.765252z m15.258382 19.510717l1.375756-12.131664h58.657221l-1.375756 12.131664h-17.509618l-6.878779 66.661619h-22.13716l-1.750962-12.131665h12.381802l5.878229-54.529954h-28.640733z m158.282259 64.160245h-94.927145l1.375756-12.757008h26.764702l10.63084-100.180031h12.757008l-10.63084 100.180031h15.883725l10.63084-100.180031h12.631939l-10.505771 100.180031h26.764702l-1.375756 12.757008z m-71.914503-32.142657h-9.255084l-3.752061-62.784489h12.757007l0.250138 62.784489z m65.035725 0h-9.130015l13.132213-62.784489h12.882077l-16.884275 62.784489z m106.136427 34.769099h-12.631939l12.131664-115.938687h12.506871l-12.006596 115.938687z m-32.392794 0.250138h-25.639084l-2.001099-11.881527h16.258932l3.126717-30.891969h-40.021985l4.252336-41.147604h38.771298l1.87603-17.634687h-39.521709l1.250687-11.50632h52.153648l-4.252335 40.647328h-38.896367l-1.87603 18.009893h40.272122l-5.753161 54.404886z m100.758474-79.793832l-1.375756 12.381801-17.509618-33.893618-24.888672 33.893618 1.375756-12.381801 18.385099-36.520061h13.132214l10.880977 36.520061z m55.90571-33.393344l-1.125619 11.881527h-20.261129l-4.87768 10.880977h21.511817l-6.253435 59.907908h-10.380702l4.877679-47.901313h-26.389496l-5.002748 47.901313h-10.380703l6.128367-59.907908h15.508519l2.626443-10.880977h-20.010993l1.125619-11.881527h52.904061z m-59.657771 49.152l-1.250687 11.756458-17.509619 30.89197 10.130565 7.379053-1.375756 14.007695-30.641832-22.887573 1.375756-13.50742 13.007145 9.505222 12.882076-24.888672h-25.514015l1.125619-12.256733h16.133862l-2.501374-17.759756h11.256183v17.759756h12.882077z m34.894168-8.254534l-3.501924 34.518962 16.884275 37.395542h-10.380703l-13.757557-25.514016-18.885374 25.514016h-10.130565l25.388947-37.395542 3.626992-34.518962h10.755909z m62.737587 10.630839h-8.879878l-3.877129 37.145405 14.132763-4.127267-1.250687 12.131664-37.395542 10.255634 1.250687-12.131665 11.256183-2.87658 4.252336-40.397191h-9.255084l1.125619-11.50632h9.255083l3.001649-28.390596h-10.255633l1.250687-11.381251h31.76745l-1.250687 11.381251h-9.755359l-2.87658 28.390596h8.754809l-1.250687 11.50632z m7.879329-38.271022l1.375755-11.756458h58.156947l-1.250687 11.756458h-32.142657l-29.015939 67.537099h-9.380152l25.764152-67.537099h-13.507419z m23.637984 99.429618h-12.381801l8.754809-82.795481h12.256733l-8.629741 82.795481z m20.26113-32.392794l-11.006046-50.402687h12.631939l7.253985 50.402687h-8.879878z m112.131908 30.516763h-94.802076l1.375756-12.882076h32.267725l9.004947-85.046718h-28.890871l1.375756-12.757007h86.172336l-7.629191 73.165191h-20.010992l-2.751512-12.757008h11.006046l5.002748-47.651176h-31.267175l-8.879878 85.046718h49.402137l-1.375756 12.882076z m42.226321-113.68745h14.758107l-25.388947 27.390046h-10.630839l21.261679-27.390046z m19.885924 6.003298h51.528305l-1.125618 12.256732h-51.653374l1.250687-12.256732z m-23.512916 23.512916h15.258381l-20.636335 21.761954h9.004946l-6.75371 64.53545h-12.381801l6.378503-60.408183-1.87603 1.876031h-11.131115l22.137161-27.765252z m15.258381 19.510717l1.375756-12.131664h58.657222l-1.375756 12.131664h-17.509619l-6.878778 66.661619h-22.13716l-1.750962-12.131665h12.381801l5.878229-54.529954h-28.640733z m158.290077 64.160245h-94.927145l1.375755-12.757008h26.764703l10.630839-100.180031h12.757008l-10.63084 100.180031h15.883726l10.630839-100.180031h12.631939l-10.505771 100.180031h26.764702l-1.375755 12.757008z m-71.914504-32.142657h-9.255084l-3.752061-62.784489h12.757008l0.250137 62.784489z m65.035725 0h-9.130015l13.132214-62.784489h12.882076l-16.884275 62.784489z m59.61087-81.044519l-5.127816 12.50687h15.758656l-10.505771 98.178931h-39.146504l10.255634-98.178931h12.757007l2.626443-12.50687h13.382351z m37.395542 0l-5.878229 11.881527h30.641832l-10.880977 103.932091h-20.010992l-2.376305-12.381801h11.50632l8.379603-79.168489h-23.262778l-7.003848 14.132764h-9.63029l14.50797-38.396092h14.007694z m-58.907358 53.154198h16.384l3.001648-28.89087h-16.384l-3.001648 28.89087z m36.019786-11.256183h14.132763l3.87713 42.023084h-9.505221l-8.504672-42.023084z m-40.897466 56.90626h16.384l3.626993-34.393893h-16.384l-3.626993 34.393893z m186.922993 11.881526h-94.927145l1.375755-12.882076h40.52226l8.379603-79.04342h-36.019786l1.250687-12.757007h85.546992l-1.375756 12.757007h-36.144855l-8.254534 79.04342h40.897466l-1.250687 12.882076z m105.511084 2.501375h-94.927146l1.375756-12.757008h26.764702l10.63084-100.180031h12.757008l-10.63084 100.180031h15.883725l10.63084-100.180031h12.631939l-10.505771 100.180031h26.764702l-1.375755 12.757008z m-71.914504-32.142657h-9.255084l-3.752061-62.784489h12.757007l0.250138 62.784489z m65.035725 0h-9.130015l13.132213-62.784489h12.882077l-16.884275 62.784489z m113.390412 32.642931h-94.927145l1.250687-12.256732h67.036825l3.001648-16.759207h-59.782839l15.008244-69.663267h-13.632489l1.375756-12.131664h89.549191l-1.250687 12.131664h-63.534901l-3.626992 16.759206h58.407084l-13.007145 69.663268h15.258381l-1.125618 12.256732z m-62.034076-69.788336l-6.128367 28.640733h46.775695l5.127817-28.640733h-45.775145z m175.674626-30.016488l-1.375756 11.756458h-18.635237l-2.376305 24.263328h20.636336l-1.375756 11.756458h-19.885924l15.133313 54.279817h-10.380702l-13.257282-37.645679-20.886474 37.645679h-10.255633l26.389496-54.279817h-20.136061l1.375756-11.756458h20.511267l2.501374-24.263328h-18.510168l1.375756-11.756458h8.504671l-4.002198-14.132763h13.382351l1.00055 14.132763h11.381252l3.752061-14.132763h13.382351l-6.878779 14.132763h8.629741z m-62.534351 67.787237l6.503572-1.250687-1.125618 11.756458-6.503573 1.250687-2.376305 22.262229h-10.63084l2.251237-19.885924-26.514565 5.503023 1.250687-12.006596 3.752061-0.750412 7.75426-74.415878h-3.501924l1.125618-11.131114h40.897466l-1.375756 11.131114h-4.377404l-7.128916 67.5371z m-16.509069-51.903512h11.50632l1.375756-15.633588h-11.256183l-1.625893 15.633588z m-2.87658 26.639634h11.381252l1.625893-16.008794h-11.256183l-1.750962 16.008794z m-3.126718 29.766351l11.631389-2.251237 1.876031-16.759206h-11.381252l-2.126168 19.010443z m90.74516 29.391145l11.756458-112.686901h90.549741l-11.756458 112.686901h-18.510168l-1.876031-11.881527h9.630291l9.130015-88.423572h-66.411481l-10.380702 100.305099h-12.131665z m43.023634-93.926596h10.755908l-13.257282 37.020336 5.002748 41.022535h-8.754809l-3.251786-21.511817-7.629191 21.511817h-8.879878l13.632489-41.022535-5.503023-37.020336h10.880977l1.87603 15.383451 5.127817-15.383451z m28.765802 36.895268l5.127816 41.147603h-9.004946l-3.251786-21.386748-7.629191 21.386748h-8.879878l13.632488-41.022535-5.503023-37.020336h10.880978l1.87603 15.258382 5.127817-15.258382h10.880977l-13.257282 36.895268z m86.250503 57.156397h-13.132213l4.002198-40.021985h-40.647328l1.375756-12.631939h40.647328l5.127817-47.776244h-36.770199l1.375756-12.381802h86.547542l-1.125618 12.381802h-36.64513l-5.252886 47.776244h40.897466l-1.375756 12.631939h-40.647328l-4.377405 40.021985z m-20.511267-61.158596h-9.880427l-6.503573-30.641832h14.382901l2.001099 30.641832z m50.027481 0h-9.880427l9.130015-30.641832h14.382901l-13.632489 30.641832z m122.27029-8.004397h-89.549191l26.01429-46.400488h14.758107l-20.386198 33.893618h51.903511l-8.004397-21.511817h14.257832l11.006046 34.018687z m-11.381252 67.286962h-80.669313l5.628092-54.529954h80.794382l-5.753161 54.529954z m-63.409832-42.148153l-3.126717 29.766352h55.030229l3.251786-29.766352h-55.155298z m92.629008 39.646779l1.250687-12.256733h12.256733l-1.375756 12.256733-7.253985 12.131664h-6.253435l7.504122-12.131664h-6.128366z m58.876091-14.633038h-9.755358l32.768-79.918901h-21.636886l1.250687-12.631939h90.674809l-1.375755 12.631939h-54.905161l-37.020336 79.918901z m38.145955-65.536h13.382351l-9.130015 84.296305h-13.132214l8.879878-84.296305z m48.026381 65.035725h-10.130565l-15.508519-65.035725h14.50797l11.131114 65.035725z m71.109374-42.023084l5.252886-50.027481h11.381252l26.889771-4.502473-1.375756 12.256733-26.889771 4.502473-2.126168 20.136061h27.765252l-1.250687 12.006595h-6.75371l-7.128916 67.412031h-11.381252l7.128916-67.412031h-9.63029l-0.750412 7.879329-13.50742 59.532702h-8.62974l11.006045-61.783939z m-25.514015-10.005496l-12.631939 45.149801h-6.503572l10.380702-45.149801h-4.752611l1.250687-11.756458h13.50742l3.376855-32.392794h10.880977l-3.376855 32.392794h10.505771l-1.250687 11.756458h-10.505771l-0.875481 7.504122h7.879329l-0.250138 31.642382h-5.75316l-2.126168-28.890871-4.252336 40.272123h-10.755908l5.252885-50.527756z m-23.13771-40.272122h11.131115l-10.005496 95.802626h36.144854l-1.125618 10.880977h-47.401038l11.256183-106.683603z m13.757557 1.500824h8.879878l-0.750412 20.761405h-6.378504l-1.750962-20.761405z m29.015939 0h8.879878l-6.253435 20.761405h-6.253435l3.626992-20.761405z m108.512733 4.752611h45.149802l-1.375756 12.50687h-20.636336l19.510718 31.142107h-13.757558l-23.888122-31.142107h-16.008794l-27.390045 31.142107h-13.882626l26.01429-31.142107h-20.761405l1.375756-12.50687h29.766351l8.504672-10.130565h16.258931l-8.879878 10.130565z m-18.385099 29.641282h13.757557l-7.879328 15.383451h46.900763l-6.253435 60.533252h-20.386198l-2.751512-12.006596h11.63139l3.752061-35.894717h-39.52171l-24.638535 47.901313h-12.256732l23.763053-47.901313h-16.133863l1.375756-12.631939h21.011542l7.629191-15.383451z m132.275786-39.771847l-0.875481 8.004397h38.521161l-2.376306 23.512916h-12.381801l1.000549-11.631389h-65.410931l-1.125618 11.631389h-12.757008l2.626443-23.512916h38.52116l0.750412-8.004397h13.50742z m-5.878229 24.638534h12.631939l-4.377404 42.898565h31.017038l-1.125619 12.006596h-28.640732l23.763053 36.269923h-12.757008l-21.261679-28.265526-43.148702 28.265526h-15.258382l49.777344-36.269923h-46.900764l1.125619-12.006596h50.652824l4.502473-42.898565z m-31.017038 0l25.138809 10.005496-1.125618 11.756459-25.263878-10.130565 1.250687-11.63139z m17.509618 41.022535l-28.765801-11.63139 1.250687-11.756458 28.765801 11.506321-1.250687 11.881527z m148.534718 48.15145h-83.170687l10.755908-102.18113h26.01429l3.626993-11.50632h15.008244l-6.75371 11.50632h45.27487l-10.755908 102.18113zM3354.967939 600.45484l-1.876031 17.384549h57.781741l1.87603-17.384549H3354.967939z m-3.126718 29.015939l-1.625893 17.509618h57.781741l1.750962-17.509618H3351.841221z m-3.001648 29.266076l-2.126168 20.010992h57.906809l2.001099-20.010992h-57.78174z m146.400732-81.92l-5.75316 8.879878h43.39884l-11.381252 106.808672h-17.759756l-1.750962-11.756458h8.254535l2.626442-26.139359h-31.642381l-34.143756 38.020885h-13.757557l31.017038-38.020885h-26.639634l1.250687-11.381252h10.505771l6.003298-57.531603h22.012092l3.626992-8.879878h14.132763z m-29.266076 28.89087h52.153649l0.875481-8.504672h-52.02858l-1.00055 8.504672z m-1.876031 18.385099h52.028581l0.875481-8.754809h-52.028581l-0.875481 8.754809z m-2.001099 19.135512h51.903512l1.000549-9.755359h-52.02858l-0.875481 9.755359z m172.172703 46.775695h-94.927146l1.375756-12.757008h26.764703l10.630839-100.180031h12.757008l-10.63084 100.180031h15.883725l10.63084-100.180031h12.631939l-10.505771 100.180031h26.764702l-1.375755 12.757008z m-71.914504-32.142657h-9.255084l-3.752061-62.784489h12.757007l0.250138 62.784489z m65.035725 0h-9.130015l13.132213-62.784489h12.882077l-16.884275 62.784489z m45.603175-21.261679h-21.511816l40.772397-21.136611-21.136611-12.882076-5.503023 6.378503h-10.255634l21.761955-32.142656h16.133862l-6.378504 7.379053h55.530504l-1.125618 12.256733-0.250137 1.250687-0.500275 4.752611-25.013741 12.631939 31.017038 21.511817h-19.510717l-24.513466-14.883176-29.516214 14.883176z m0-36.269924h21.136611l11.631389 8.129466 20.636336-10.755909 0.125069-1.250687h-50.15255l-3.376855 3.87713z m9.380153 32.017588h16.008794l-5.878229 9.63029h44.899664l-5.252885 50.652824h-20.761405l-2.251237-10.880977h11.506321l2.87658-27.515114h-38.52116l-23.512916 38.396091h-12.50687l21.261679-38.396091h-15.258382l1.250687-12.256733h20.761405l5.377954-9.63029z m125.647145-20.636336h-46.900763l13.382351-34.894168h12.631939l-9.880428 24.263328h18.134962l-2.376305-15.133313h12.131664l2.87658 25.764153z m42.023084 16.634137h-39.896916l5.503023-51.528305h12.256733l-1.500825 15.258382 29.141008-12.631939-1.375756 13.007145-29.141007 11.881526-1.125619 12.256733h30.516764l-4.377405 11.756458z m-83.670962 64.285313h-11.131114l7.629191-74.415878h42.39829l-7.75426 74.415878h-16.133862l-2.126168-9.63029h7.62919l1.750962-16.509068h-19.510717l-2.751512 26.139358z m6.75371-63.785038l-1.000549 9.255084h19.510717l0.875481-9.255084h-19.385649z m70.41368 61.533802h-39.771848l6.003298-57.656672h12.256733l-1.750962 18.134962 29.141008-13.882626-1.375756 12.882076-29.141008 13.257283-1.500824 15.508519h30.516763l-4.377404 11.756458z m-72.539848-42.648428l-0.875481 9.255084h19.510718l1.00055-9.255084h-19.635787z m139.271817-71.039023l-5.127817 15.383451h53.529405l-10.63084 100.555236h-28.515664l-2.626443-12.131664h19.135512l8.004397-75.791633h-43.148703l-29.266076 87.923297h-11.631389l27.139908-87.923297h-18.009893l1.375756-12.631939h20.511267l4.752611-15.383451h14.507969z m64.988825 111.436214l1.250687-12.256733h12.256732l-1.375755 12.256733-7.253985 12.131664h-6.253435l7.504122-12.131664h-6.128366z m110.779603-111.311145l-9.505222 21.636885h47.901313l-9.880427 94.301802h-20.386199l-1.87603-12.006595h10.255633l7.379054-70.288611h-38.646229l-36.144855 82.295206h-11.506321l32.893069-82.295206h-22.887573l1.375756-12.006596h11.381252l-4.502473-17.884824h13.257282l1.125618 17.884824h5.127817l8.629741-21.636885h16.008794z m-9.130016 52.528855h14.132764l2.87658 28.015389h-9.380153l-7.629191-28.015389z m61.61197 63.034626h-9.004947l11.506321-46.650626 6.75371-65.285863h84.546442l-11.631389 111.936489h-17.884824l-2.001099-11.381252h8.754809l3.001649-28.640733h-23.888123l-4.002198 37.64568h-12.131664l4.002198-37.64568H4152.280916l-13.757557 40.021985z m20.26113-100.555237l-1.876031 19.26058h24.013191l2.001099-19.26058h-24.138259z m36.269923 0l-2.001099 19.26058h23.888122l2.001099-19.26058h-23.888122z m-39.396641 30.266626l-2.001099 19.010443h24.138259l1.876031-19.010443h-24.013191z m36.144855 0L4189.801527 641.102168h24.013191l1.87603-19.010443h-23.888122z m53.732641 70.788886h-10.63084l13.50742-52.403787 5.628092-52.403786h34.393893l1.250687-11.381252h13.632489l-1.375756 11.381252h35.144305l-5.75316 54.90516h-70.413679l-15.383451 49.902413z m20.010993-92.55084l-3.251787 30.391695h57.531603l3.126718-30.391695h-57.406534z m112.632183 21.261679l-1.250687 13.007145-7.629191 3.376855-5.75316 54.655023h-14.257832l-2.876581-11.631389h6.878779l3.87713-37.770748-10.755909 4.752611 1.375756-12.757008 10.755908-4.752611 2.626443-25.388946h-10.380702l1.250687-12.006596h10.255634l1.750961-16.384h11.63139l-1.750962 16.384h7.379053l-1.250687 12.006596h-7.379053l-2.001099 19.885923 7.504122-3.376855z m9.63029-41.647877h56.155847l-4.877679 47.025832h-56.280916l5.002748-47.025832z m9.755359 18.134961h32.642931l1.00055-7.379053h-32.642932l-1.000549 7.379053z m-1.750962 18.009893h32.642931l0.875481-8.254534h-32.642931l-0.875481 8.254534z m8.004397 28.765802h-26.639634l1.250687-11.006046h63.65997l-1.250687 11.006046h-24.888672l-1.250687 11.131115h22.762504l-1.125619 10.630839h-22.637435l-1.750962 15.008244h25.639084l-4.127267 11.256184h-41.39774l-11.506321-8.004397-2.751511 7.754259h-9.380153l11.381252-41.898015h13.132214l-8.254535 22.762504 11.506321 8.004397h3.752061l3.87713-36.64513z m85.249954-68.162443l-18.009893 32.017588h6.878778l-8.879877 84.171237h-12.381802l7.879328-74.040672h-10.005496l20.761405-42.148153h13.757557z m61.783939 16.258932l-1.250687 12.131664h-10.63084l-3.376855 33.018137h12.50687l-1.250687 12.006596h-68.787786l1.125618-12.006596h12.631939l3.501924-33.018137h-10.63084l1.250687-12.131664h10.755909l1.625893-16.258932h12.256733l-1.750962 16.258932h19.135511l1.500825-16.258932h12.381801l-1.625893 16.258932h10.63084z m-46.650626 45.149801h18.885374l3.501924-33.018137h-18.885374l-3.501924 33.018137z m-19.635786 54.780092h-10.005497l15.758657-36.269924h13.632488l-19.385648 36.269924z m47.651175 0L4519.459176 656.610687h13.632488l9.255084 36.269924h-10.130565z m89.377222-115.938687l35.144305 40.021984-1.375756 12.631939-17.384549-16.634137-1.250687 11.756458h-56.90626l1.250687-11.631389-20.636336 16.509068 1.375756-12.631939 43.39884-40.021984h16.384z m-9.380153 11.381252l-30.016489 23.888122h55.030229l-25.01374-23.888122z m25.263878 102.306198h-72.164641l5.503022-52.653924h72.28971l-5.628091 52.653924z m-8.754809-40.272122h-46.150352l-2.87658 27.640183h46.025283l3.001649-27.640183z m77.120488-23.512916l-1.125618 11.256183h-12.631939l8.254534 54.529954h-9.63029l-6.878778-31.892519-13.632489 31.892519h-9.505221l19.635786-54.529954h-13.007145l0.875481-11.256183h13.382351l2.376305-22.887573h-11.50632l1.250687-10.880977h11.50632l1.625893-16.384h11.381252l-1.625893 16.384h11.131115l-1.250687 10.880977h-11.131115l-2.376305 22.887573h12.882076z m11.256183 20.511267l15.883726-48.026382h13.132213l-34.64403 93.55139h-9.505222l12.757008-38.646229h-9.130015l7.879328-73.915603h49.777344l-8.004397 73.915603h-10.63084l6.503572-61.909008h-28.265526l-5.753161 55.030229z m13.382352-3.752061h10.880977l-4.002199 35.394443h19.510718l-4.377405 12.006595h-26.889771l4.87768-47.401038z m51.348519 56.90626l-5.503023-24.513466h12.256733l5.377954 24.513466h-12.131664zM4918.561221 597.203053h-65.536l-1.000549 10.130565h-12.631939l2.251236-22.262229h38.646229l0.875481-8.254534h13.382352l-0.750413 8.254534h38.521161l-2.376306 22.262229h-12.381801l1.000549-10.130565z m-14.633038 13.50742h12.381802l-0.500275 5.252886h14.382901l-1.375756 12.757007h-14.382901l-2.126168 20.26113-0.500275 5.75316-23.512916 14.382901 35.019237 23.387848h-22.762504l-24.263328-16.008794-26.264427 16.008794h-21.636886l37.520611-22.887573-20.26113-13.382351 5.75316-27.515115h-15.508519l1.375756-12.757007h16.759206l1.125618-5.252886h12.381802l-1.125618 5.252886h37.020335l0.500275-5.252886z m-25.889221 51.653374l21.887023-13.382351 2.126168-20.26113h-38.396092l-4.502473 21.011542 18.885374 12.631939zM73.728 842.712916l34.143756 35.019237-1.125619 11.381252-43.899114-34.7691-51.028031 34.7691 1.250687-11.381252 41.272672-35.019237h19.385649z m19.760855 79.918901h-31.267176l-2.251236 21.386748h38.896366l-1.375756 12.381801H6.691176l1.375755-12.381801H46.588092l2.251236-21.386748H17.82229l1.250687-12.381802h31.017038l1.750962-16.258931H26.452031l1.125618-12.50687h64.53545l-1.000549 12.50687H65.223328l-1.87603 16.258931h31.392244l-1.250687 12.381802z m32.345893 43.648977l-5.503023-24.513466h12.256733l5.377954 24.513466h-12.131664z m151.106443-105.933191H182.014046l1.250687-11.256183h40.897465l0.500275-6.503573h13.382351l-0.750412 6.503573h40.772397l-1.125618 11.256183z m-12.006596 34.393893h-78.167939l3.001649-28.390595h78.042871l-2.876581 28.390595z m-64.160244-18.510168l-0.875481 8.504672h53.904611l0.875481-8.504672h-53.904611z m62.65942 82.170138h-15.758656l-1.750962-10.880977h6.378503l3.752062-35.769649h-64.035176l-4.877679 46.525557H175.018015l6.003298-57.656672h88.548641l-6.128366 57.781741z m-20.26113-9.505222h-46.150351l3.376855-30.891969h46.025282l-3.251786 30.891969z m-32.392794-20.511267l-1.250687 10.255634h23.387848l1.125618-10.255634h-23.262779z m152.536916-85.922198l-6.503572 13.257282h27.01484l-1.00055 12.256733h-4.877679l-0.875481 8.62974-0.625344 5.002748-14.382901 27.515115 11.131115 49.527206H362.93374l-9.380152-33.268275-17.38455 33.268275H325.41313l0.125068-0.250137H317.283664l-11.631389-27.139909-17.134412 27.139909h-10.130565l22.387297-38.521161-11.381251-26.764702h13.632488l5.252886 14.007695 8.129465-14.007695h13.50742l-16.884275 26.639634 13.50742 36.520061 22.637435-46.400489-7.879328-28.265527h-6.628641l14.507969-39.146503h14.132764z m-43.273771 9.130015h18.260031l-1.375756 12.256733h-47.526107l1.375756-12.256733h17.38455l0.875481-9.130015h11.881526l-0.875481 9.130015z m38.020886 40.021985l7.379053-15.008245 0.875481-8.62974h-15.633588l-5.127816 10.255633h9.505221l3.001649 13.382352z m-64.285313-22.512367h13.632488l-12.882076 20.511267h-10.130565l9.380153-20.511267z m40.647328 20.511267H324.162443l-7.003848-20.511267h13.757558l3.501923 20.511267z m91.753527-47.025832l-5.127817 12.506871h15.758657l-10.505771 98.178931h-39.146504l10.255633-98.178931h12.757008l2.626443-12.506871h13.382351z m37.395542 0l-5.878229 11.881527h30.641832l-10.880977 103.932092h-20.010993l-2.376305-12.381802h11.506321l8.379603-79.168488h-23.262779l-7.003847 14.132763h-9.63029l14.507969-38.396092h14.007695z m-58.907359 53.154199h16.384l3.001649-28.89087h-16.384l-3.001649 28.89087z m36.019786-11.256183h14.132764l3.877129 42.023084h-9.505221l-8.504672-42.023084z m-40.897465 56.906259h16.384l3.626992-34.393893h-16.384l-3.626992 34.393893z m100.133129-29.391145l6.996031-66.661618h32.142656l-11.756458 112.561832H513.172519l-2.001099-11.506321h6.75371l3.251786-30.516763h-11.256183l-12.006596 42.148153h-7.504122l9.505222-46.025283z m82.162321-55.405435h-26.139359l-3.376855 31.517313h38.271023l-1.000549 11.381252-0.500275 4.127267-14.633038 25.263878 11.256183 29.266076h-10.63084l-7.629191-17.009343-9.880427 17.009343h-10.63084l15.258382-28.765801-11.131115-24.763603h14.007695l4.252336 11.131114 8.62974-16.258931h-26.639633l-6.253435 58.657221h-11.756458l11.756458-112.811969h49.152l-3.87713 37.895817h-22.262229l-2.376306-11.63139h14.633039l1.500824-15.008244z m-67.787237 19.010443h11.006046l2.001099-19.26058h-11.256183l-1.750962 19.26058z m-3.376855 29.89142h11.256184l2.126168-19.385649h-11.256184l-2.126168 19.385649z m113.765619-3.126718h-21.511817l40.772397-21.136611-21.136611-12.882076-5.503023 6.378504H607.052214l21.761954-32.142657h16.133863l-6.378504 7.379054h55.530504l-1.125619 12.256733-0.250137 1.250687-0.500275 4.75261-25.01374 12.631939 31.017038 21.511817h-19.510718l-24.513465-14.883176-29.516214 14.883176z m0-36.269924h21.13661l11.63139 8.129466 20.636336-10.755908 0.125068-1.250687h-50.152549l-3.376855 3.877129z m9.380152 32.017588h16.008794l-5.878229 9.63029h44.899664l-5.252885 50.652825h-20.761405l-2.251236-10.880977h11.50632l2.87658-27.515115h-38.52116l-23.512916 38.396092h-12.50687l21.261679-38.396092h-15.258381l1.250687-12.256733h20.761404l5.377954-9.63029z m80.372275 55.780641l1.250687-12.256732h12.256733l-1.375756 12.256732-7.253984 12.131664h-6.253435l7.504122-12.131664h-6.128367z m62.127878 4.377405h-12.381801l12.006595-112.81197h90.174534l-12.006595 112.81197h-21.511817l-1.625893-12.256733h12.131664l9.255084-88.67371h-65.410931l-10.63084 100.930443z m68.787786-80.04397h-55.405435l1.375756-11.381251h55.155298l-1.125619 11.381251z m-10.505771 56.90626h-46.275419l4.877679-46.27542h46.400488l-5.002748 46.27542z m-31.017038-35.144305l-2.376305 23.512916h23.012641l2.376305-23.512916h-23.012641z m149.910473 58.407084h-20.386198l-2.501374-12.006596h11.756458l8.004397-75.16629h-30.516763l1.375755-12.006595h30.516764l1.500824-16.634138h12.256733l-1.625893 16.634138h9.380152l-1.375755 12.006595h-9.380153l-9.004947 87.172886z m-46.025282-8.254535h-36.64513l10.755909-100.805374h36.394992l-10.505771 100.805374z m-16.133863-89.173984l-3.126717 30.641832h14.007695l3.126717-30.641832h-14.007695z m45.900214 64.660519h-8.879878l-7.253984-43.273771h13.132213l3.001649 43.273771z m-50.027481-23.13771l-3.877129 36.019786h14.007694l3.752061-36.019786h-13.882626z m178.168183 54.029679h-81.669862l7.379053-71.539298-9.380152 1.876031 1.375755-13.007145 9.380153-2.126168 2.501374-23.637985h12.006596l-2.251237 21.26168 21.887023-4.377405 2.251236-22.262229h12.006596l-2.126168 19.635786 35.394443-7.128916-7.75426 73.790535h-20.636336l-1.87603-12.631939h12.006595l4.752611-45.399939-23.262779 4.877679-5.878229 57.656672h-12.131664l5.878229-55.405435-21.887023 4.377404-6.503572 61.783939h73.665465l-5.127817 12.256733z m24.466565 1.876031h-9.380152l12.131664-51.1531 5.878229-57.156397h36.019786l0.750412-7.504122h13.132214l-0.750412 7.504122h35.269374l-3.501924 32.517863h-72.039572l-2.376306 23.637985-15.133313 52.153649z m20.010993-97.553588l-1.250687 11.006046h59.657771l1.125618-11.006046h-59.532702z m7.879328 97.553588h-12.131664l7.128916-67.286962h64.53545l-7.128916 67.161893h-16.634137l-1.750962-10.380702h7.379053l1.125619-10.63084h-40.397191l-2.126168 21.136611z m5.878229-56.656122l-0.750412 8.129465h40.272122l1.00055-8.129465h-40.52226z m-1.876031 17.759755l-0.87548 8.254535h40.522259l0.750412-8.254535h-40.397191z m135.027298-55.280366h-38.020885l-9.505222 8.62974h-11.881526l29.141007-30.266626h16.133863l-9.63029 8.754809h40.147053l-1.375756 12.882077-12.381801 11.006046h22.387298l-6.128367 55.655572h-12.381801l4.502473-42.773496h-50.402687l-4.502473 42.773496h-12.506871l5.878229-55.655572h41.272672l9.255084-11.006046z m-8.62974 30.766901l-2.251237 23.637984 36.019786 39.771848h-13.50742l-30.516763-25.639084-36.019786 25.639084h-13.50742l44.774595-39.771848 2.251237-23.637984h12.757008z m82.498442-52.278718l0.875481 16.884275h-9.880427l-5.628092-16.884275h14.633038z m63.159695 33.143206l-1.125618 12.256733h-20.886473l-5.753161 54.029679h23.763054l-1.250687 11.881527h-61.408733l1.125618-11.881527h24.888672l5.75316-54.029679h-20.26113l1.125619-12.256733h20.261129l3.501924-33.143206h12.882076l-3.501923 33.143206h20.886473z m-56.405985-11.631389l-1.250687 11.256183-18.635236 21.887023h7.003847l-6.378504 60.908458h-12.381801l5.628091-53.779542-2.751511 3.251786h-11.756458l24.138259-32.267725h-17.384549l1.250687-11.256183h32.517862z m0.625344 33.143206l1.375756 27.640183h-8.379603l-4.502474-27.640183h11.506321z m130.391939-54.655023l34.143756 35.269374-1.250687 11.631389-43.39884-37.52061-51.528306 37.52061 1.250688-11.631389 41.39774-35.269374h19.385649z m-42.273222 48.026382l1.250687-12.006596h55.155298l-1.125618 12.006596h-55.280367z m-2.87658 24.138259h-17.509618l1.375756-11.881526h90.799878l-1.375756 11.881526h-59.532702l-15.008245 29.391145h53.279267l-5.75316-20.261129h13.257283l7.62919 32.517862h-86.797679l19.635786-41.647878z m178.551206-37.52061h-33.518412l-1.000549 7.379053h41.022534l-1.00055 11.006046H1512.627786l1.125619-11.006046h41.022534l0.875481-7.379053h-33.643481l0.875481-9.755359h33.643481l0.750412-7.003848h-37.770748l1.125618-11.256183h37.895817l0.750412-6.75371h12.882077l-0.750413 6.75371h37.770748l-1.125618 11.256183h-37.895817l-0.750412 7.003848h33.643481l-1.00055 9.755359z m-3.626992 25.138809l-3.626992 34.64403h-12.631939l2.376305-23.637984h-53.02913l-2.376305 23.637984h-12.50687l3.626992-34.64403h78.167939z m-47.275969 15.133313h12.882076l-1.00055 10.880977 37.145405 29.89142h-13.50742l-31.392244-18.885374-35.144306 18.885374h-13.507419l43.398839-29.766351 1.125619-11.006046z m91.253251-75.041222h14.382901l-21.13661 31.767451h8.62974l-8.879878 84.171236h-12.50687l8.004397-77.04232-2.126168 3.251786h-9.880428l23.512916-42.148153z m73.415329 2.626443l-1.250687 12.131664-23.262779 3.87713-3.126717 29.89142h25.764152l-1.250687 12.131664h-25.764153l-4.127267 38.896366h23.387848l-1.250687 12.006596h-59.907909l1.250687-12.006596h23.637985l4.002198-38.896366h-25.889221l1.250687-12.131664h26.01429l3.126718-29.89142h-23.13771l1.375756-12.256733h36.019786l23.13771-3.752061z m13.585588 108.684702l1.250687-12.256732h12.256732l-1.375755 12.256732-7.253985 12.131664h-6.253435l7.504122-12.131664h-6.128366z m86.641343-63.284763l-1.375756 12.882076-8.754809 2.87658-5.377954 52.028581h-14.883176l-2.87658-11.63139h6.878779l3.87713-36.269923-12.131665 4.002198 1.375756-12.757007 12.006596-4.002199 2.87658-26.514565h-11.63139l1.125619-11.756458h11.756458l1.750962-17.009343h11.881526l-1.750961 17.009343h8.62974l-1.375756 11.756458h-8.504672l-2.251236 22.387298 8.754809-3.001649z m58.907359-44.899664l-3.001649 29.141008h8.62974l-4.377404 11.50632h-17.38455l3.001649-29.266076h-20.761405l-10.255633 31.142107h-9.880428l8.629741-36.895268 0.625343-5.628091h44.774596z m-12.757008 57.156397h-43.899114l1.250687-11.381252h56.030778l-1.125618 11.381252-0.500275 4.127267-0.500275 4.627542-22.387297 19.885924 20.636336 27.139908h-11.756458l-17.134413-19.635786-22.012091 19.635786h-13.007145l28.515664-27.264977-18.009893-20.636336h17.009343l9.505222 12.50687 17.009343-16.258931 0.375206-4.127267z m83.366107-60.283115l-5.75316 8.879878h43.398839l-11.381251 106.808672h-17.759756l-1.750962-11.756458h8.254534l2.626443-26.139359h-31.642382l-34.143755 38.020886h-13.757558l31.017039-38.020886h-26.639634l1.250687-11.381252h10.505771l6.003298-57.531603h22.012091l3.626993-8.879878h14.132763z m-29.266076 28.890871h52.153649l0.87548-8.504672h-52.02858l-1.000549 8.504672z m-1.876031 18.385099h52.02858l0.875481-8.754809h-52.02858l-0.875481 8.754809z m-2.001099 19.135511h51.903511l1.00055-9.755359h-52.02858l-0.875481 9.755359z m96.130931-13.50742h-12.381801l31.267175-52.778992h15.133313l-34.018687 52.778992z m82.670412 0h-12.381801l-23.012641-52.778992h15.258381l20.136061 52.778992z m-11.381251 60.908458h-86.79768l32.768-69.788335h14.132763l-28.265526 57.531603h52.528855l-10.755909-39.896916h13.382351l13.007146 52.153648z m115.766717-42.273221h-94.927145l1.250687-12.757008h20.386199l3.376855-30.516763h-17.509619l1.250687-12.631939h17.38455l1.750962-15.758656h12.882076l-1.750962 15.758656h28.140458l1.625893-15.758656h12.882077l-1.625893 15.758656h17.384549l-1.250687 12.631939h-17.38455l-3.251786 30.516763h20.511267l-1.125618 12.757008z m-57.156397-43.273771l-3.251786 30.516763h28.140458l3.251786-30.516763h-28.140458z m-30.016488 87.798229h-11.381252l18.885374-36.394992h15.508519l-23.012641 36.394992z m81.419725 0h-11.506321l-15.508519-36.394992h15.508519l11.506321 36.394992z m21.214778-46.650626l7.003848-66.661618h32.142656l-11.756458 112.561832h-14.132763l-2.001099-11.506321h6.75371l3.251786-30.516763h-11.256183l-12.006596 42.148153h-7.504122l9.505221-46.025283z m82.170138-55.405435h-26.139359l-3.376855 31.517313h38.271023l-1.00055 11.381252-0.500274 4.127267-14.633039 25.263878 11.256184 29.266076h-10.63084l-7.629191-17.009343-9.880427 17.009343h-10.63084l15.258382-28.765801-11.131115-24.763603h14.007695l4.252336 11.131114 8.62974-16.258931h-26.639634l-6.253435 58.657221h-11.756458l11.756458-112.811969h49.152l-3.877129 37.895817h-22.262229l-2.376306-11.63139h14.633038l1.500825-15.008244z m-67.787237 19.010443h11.006046l2.001099-19.26058h-11.256183l-1.750962 19.26058z m-3.376855 29.89142h11.256183l2.126168-19.385649h-11.256183l-2.126168 19.385649z m113.757802-3.126718h-21.511817l40.772397-21.136611-21.136611-12.882076-5.503023 6.378504h-10.255633l21.761954-32.142657h16.133863l-6.378504 7.379054h55.530504l-1.125619 12.256733-0.250137 1.250687-0.500275 4.75261-25.01374 12.631939 31.017038 21.511817h-19.510718l-24.513466-14.883176-29.516213 14.883176z m0-36.269924h21.13661l11.63139 8.129466 20.636336-10.755908 0.125068-1.250687h-50.152549l-3.376855 3.877129z m9.380152 32.017588h16.008794l-5.878229 9.63029h44.899664l-5.252885 50.652825h-20.761405l-2.251236-10.880977h11.50632l2.87658-27.515115h-38.52116l-23.512916 38.396092h-12.50687l21.261679-38.396092h-15.258381l1.250687-12.256733h20.761404l5.377954-9.63029z m122.520428 60.533252h-23.637985l-2.126168-10.380702h14.382901l1.00055-10.755909h-36.269924l1.00055-9.63029h36.394992l0.625343-6.378504h-41.022534l1.125618-10.755908h41.022535l0.625343-6.128366h-35.894717l1.125618-9.63029h35.894718l0.625343-5.503023h-34.143756l2.626443-25.013741h34.018687l0.625344-5.628091h-41.022535l1.125619-10.63084h40.897465l0.625344-5.75316h12.757007l-0.625343 5.75316h41.147603l-1.125618 10.63084h-41.272672l-0.500275 5.628091h34.143756l-2.626443 25.013741h-34.143756l-0.625343 5.503023h36.019786l-1.625893 15.758656h5.127817l-1.125619 10.755908h-5.127816l-1.625894 16.008794h-36.144854l-2.251237 21.136611z m-25.764153-85.046718l-0.750412 6.628642h22.262229l0.750412-6.628642H2441.966412z m34.769099 0l-0.750412 6.628642h22.387298l0.750412-6.628642h-22.387298z m-3.126717 31.017039l-0.875481 6.128366h24.638534l0.750413-6.128366h-24.513466z m-1.876031 16.884274l-0.750412 6.378504h24.763603l0.375206-6.378504h-24.388397z m144.157313 34.268825h-94.927145l1.375756-12.757008h26.764702l10.63084-100.18003h12.757008l-10.63084 100.18003h15.883725l10.63084-100.18003h12.631939l-10.505771 100.18003h26.764702l-1.375756 12.757008z m-71.914503-32.142657h-9.255084l-3.752062-62.784488h12.757008l0.250138 62.784488z m65.035725 0h-9.130016l13.132214-62.784488h12.882077l-16.884275 62.784488z m29.094107 30.266626l1.250687-12.256732h12.256732l-1.375755 12.256732-7.253985 12.131664h-6.253435l7.504122-12.131664h-6.128366z m128.164152-111.311145l-6.003297 13.257283h31.017038l-1.250687 12.006595h-5.753161l-1.125618 11.506321-0.500275 4.127267-14.883175 27.01484 12.757007 47.901313h-9.63029l-11.006046-33.76855-18.635236 33.76855h-9.755359l23.888122-47.651176-9.505221-29.141008h-6.503573l1.500825 8.129466h-47.651176l12.381802-32.392794h-8.504672l1.250687-11.631389h47.275969l-1.250687 11.631389h-25.639084l-9.380152 20.886473h18.009893l-3.126718-12.381801h12.131664l2.876581 15.633588 13.132213-38.896367h13.882626z m-2.751511 52.02858l7.629191-15.258381 1.125618-11.506321h-17.509618l-5.002748 11.006046h9.505221l4.252336 15.758656z m-45.024733 39.021436l18.760305-5.503023-1.375755 12.006595-49.902413 14.382901 1.375756-12.131664 19.010443-5.252886 1.87603-19.635786h-16.384l1.250687-11.756458h16.258932l1.250687-11.381252h12.006595l-1.125618 11.381252h15.258382l-1.125619 11.756458h-15.508519l-1.625893 16.133863z m125.764397-91.175084l-5.127817 15.38345h53.529405l-10.63084 100.555237h-28.515664l-2.626443-12.131664h19.135512l8.004397-75.791634h-43.148703l-29.266076 87.923298h-11.631389l27.139908-87.923298h-18.009893l1.375756-12.631939h20.511267l4.75261-15.38345h14.50797z m109.013008 115.563481h-23.387848l-3.126717-11.756458h14.3829l4.627542-45.525008h-41.772946l1.250687-12.131664h41.898015l3.001649-29.516214h-36.520061l1.250687-12.381801h84.296305l-1.250687 12.381801h-34.393893l-3.001649 29.516214h39.646779l-1.250687 12.131664h-39.646779l-6.003297 57.281466z m74.744183 0.375206h-11.006046l9.380153-87.923298-16.509069 82.92055h-5.252886l13.382352-82.92055h-3.501924l1.250687-11.631389h11.756458l1.87603-16.258932h10.755909l-1.750962 16.258932h8.629741l-1.125619 11.631389h-8.62974l-9.255084 87.923298z m78.293007-99.554687h-54.029679l1.125618-11.256184h54.154748l-1.250687 11.256184z m-32.017587 99.554687h-16.258932l-1.87603-11.131115h7.379053l6.128367-58.282015h-23.763054l1.00055-11.506321h60.783389l-1.125618 11.506321h-25.013741l-7.253984 69.41313z m-31.642382-34.018687h-5.503023l-0.375206-43.523909h7.379053l-1.500824 43.523909z m1.500824 29.015939h-7.253984l13.382351-53.779542h11.756458l-17.884825 53.779542z m56.656122 0h-7.253984l-6.503573-53.779542h11.63139l2.126167 53.779542z m51.856611 5.252885h-12.256733l7.128916-68.662718h-7.128916l16.008794-47.526106h12.757008l-5.377954 14.132763h17.759755l1.500825-14.132763h11.631389l-1.500824 14.132763h22.13716l-1.125618 11.381252h-22.012092l-1.87603 16.509069h20.761404l-1.250687 11.131114h-20.761404l-1.625894 16.509069h20.761405l-1.250687 11.006046h-20.761405l-1.750961 17.509618h23.262778l-1.125618 11.381252h-53.279267l-0.625344 6.628641z m-11.881527-78.543145h-8.754809l-7.128916-34.018687h13.50742l2.376305 34.018687z m21.511817-12.131664l-1.87603 16.509069h18.385099l1.625893-16.509069h-18.134962z m-39.146504 86.797679h-12.757007l20.636336-62.284213h8.62974l-16.509069 62.284213z m36.019787-59.157496l-1.625893 16.509069h18.26003l1.625893-16.509069h-18.26003z m-2.87658 27.515115l-1.876031 17.509618h18.385099l1.876031-17.509618h-18.385099z m148.777038 35.269374H3292.433588l12.131664-115.938687h12.50687l-12.006595 115.938687z m-32.392794 0.250137h-25.639084l-2.001099-11.881527h16.258931l3.126717-30.891969h-40.021984l4.252336-41.147603H3267.419847l1.876031-17.634687h-39.52171l1.250687-11.506321h52.153649l-4.252336 40.647328h-38.896366l-1.876031 18.009894h40.272122l-5.75316 54.404885z m100.758473-79.793832l-1.375756 12.381802-17.509618-33.893619-24.888672 33.893619 1.375756-12.381802 18.385099-36.520061h13.132214l10.880977 36.520061z m55.90571-33.393344l-1.125618 11.881527h-20.26113l-4.877679 10.880977h21.511816l-6.253435 59.907909h-10.380702l4.877679-47.901313h-26.389496l-5.002748 47.901313h-10.380702l6.128366-59.907909h15.508519l2.626443-10.880977h-20.010992l1.125618-11.881527h52.904061z m-59.657771 49.152l-1.250687 11.756458-17.509618 30.89197 10.130565 7.379053-1.375756 14.007695-30.641832-22.887572 1.375756-13.50742 13.007145 9.505221 12.882076-24.888672h-25.514015l1.125618-12.256733h16.133863l-2.501375-17.759755h11.256184v17.759755h12.882076z m34.894168-8.254534l-3.501924 34.518962 16.884275 37.395542h-10.380702l-13.757557-25.514015-18.885374 25.514015h-10.130565l25.388946-37.395542 3.626993-34.518962h10.755908z m61.737038 43.148702l-1.750962 16.634138-0.875481 7.879328h-24.513465l1.750962-16.634137 0.87548-7.879329h24.513466z m-17.009343 7.879329l-1.00055 8.754809h7.879328l1.00055-8.754809h-7.879328z"
                    fill="#666666"
                    p-id="807"
                  ></path>
                </svg> -->
                <!-- <svg
                  width="127"
                  height="36"
                  viewBox="0 0 127 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.2716 0.329749L10.535 5.40912H7.56263L5.8695 0.329749H10.2716ZM29.2723 10.3004L28.9336 13.9876H22.6503L20.9195 30.2416H28.0683L27.692 33.816H9.21813L9.55675 30.2416H17.0441L18.7749 13.9876H12.6796L13.0183 10.3004H19.1135L20.167 0.329749H24.0424L22.9889 10.3004H29.2723ZM12.3034 6.80125L11.9271 10.1875L6.321 16.7719H8.428L6.50913 35.0953H2.78425L4.47738 18.9165L3.64963 19.8947H0.112875L7.3745 10.1875H2.14463L2.52088 6.80125H12.3034ZM12.4915 16.7719L12.9054 25.087H10.3845L9.03 16.7719H12.4915ZM51.7197 0.329749L61.9913 10.94L61.6151 14.4391L48.5592 3.15162L33.0577 14.4391L33.4339 10.94L45.8878 0.329749H51.7197ZM39.0024 14.7777L39.3787 11.1657H55.9713L55.6327 14.7777H39.0024ZM38.1371 22.0394H32.8696L33.2834 18.465H60.5992L60.1853 22.0394H42.2758L37.7608 30.8813H53.7891L52.0583 24.786H56.0466L58.3417 34.5685H32.2299L38.1371 22.0394ZM91.8509 10.7519H81.7674L81.4664 12.9717H93.8074L93.5064 16.2827H64.949L65.2876 12.9717H77.6286L77.892 10.7519H67.7709L68.0342 7.81712H78.1554L78.3811 5.71012H67.0184L67.357 2.32387H78.7574L78.9831 0.292125H82.8585L82.6327 2.32387H93.9955L93.6569 5.71012H82.2565L82.0307 7.81712H92.1519L91.8509 10.7519ZM90.7597 18.3145L89.6686 28.7366H85.8685L86.5834 21.6255H70.6304L69.9155 28.7366H66.153L67.2441 18.3145H90.7597ZM76.5375 22.8671H80.4129L80.1119 26.1405L91.2865 35.1329H87.223L77.7791 29.4515L67.2065 35.1329H63.143L76.1989 26.1781L76.5375 22.8671ZM103.989 0.292125H108.316L101.957 9.84887H104.553L101.882 35.1705H98.1195L100.528 11.9935L99.8879 12.9717H96.9155L103.989 0.292125ZM126.075 1.08225L125.699 4.73187L118.7 5.89825L117.76 14.8906H125.511L125.134 18.5402H117.384L116.142 30.2416H123.178L122.802 33.8536H104.779L105.155 30.2416H112.267L113.471 18.5402H105.682L106.058 14.8906H113.884L114.825 5.89825H107.864L108.278 2.211H119.114L126.075 1.08225Z"
                    fill="#D7000F"
                  />
                </svg> -->
                <div
                  style="
                    color: #d7000f;
                    font-family: MiSans;
                    font-size: 37.625px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 46px;
                    margin-bottom: 17px;
                  "
                >
                  社会责任
                </div>
                <div class="zerenContent">
                  Eiiplat互联网平台作为行业引领环卫行业的工业互联网平台，不断夯实自身业务能力，为用户提供合规、安全、高效的服务，同时也肩负社会责任，投身公共服务事业，致力于标准引领。
                </div>
                <div style="display: flex; position: relative; left: -28px">
                  <div class="zerenBox">
                    <div>
                      <img
                        src="../assets/images/img_paiming_l.png"
                        alt=""
                        style="width: 18.485px; height: 32.75px"
                      />
                      <span class="zerenBox_title">一个权威</span>
                      <img
                        src="../assets/images/img_paiming_l.png"
                        alt=""
                        style="
                          width: 18.485px;
                          height: 32.75px;
                          transform: rotateY(180deg);
                        "
                      />
                    </div>
                    <div style="margin-top: 15px; display: flex; width: 245px">
                      <div>
                        <img
                          src="../assets/images/zrLogo.png"
                          alt=""
                          style="width: 22px"
                        />
                      </div>
                      <div class="zerenBox_text">
                        中国城市环境卫生协会智慧环卫专委会主任单位，并主持了行业发展规划和数据标准制定
                      </div>
                    </div>
                  </div>
                  <div class="zerenBox">
                    <div>
                      <img
                        src="../assets/images/img_paiming_l.png"
                        alt=""
                        style="width: 18.485px; height: 32.75px"
                      />
                      <span class="zerenBox_title">两个第一</span>
                      <img
                        src="../assets/images/img_paiming_l.png"
                        alt=""
                        style="
                          width: 18.485px;
                          height: 32.75px;
                          transform: rotateY(180deg);
                        "
                      />
                    </div>
                    <div style="display: flex; width: 245px; margin-top: 15px">
                      <div>
                        <img
                          src="../assets/images/zrLogo.png"
                          alt=""
                          style="width: 22px"
                        />
                      </div>
                      <div class="zerenBox_text">
                        工信部认定环境行业第一个工业互联网平台示范
                      </div>
                    </div>
                    <div style="margin-top: 10px; display: flex; width: 245px">
                      <div>
                        <img
                          src="../assets/images/zrLogo.png"
                          alt=""
                          style="width: 22px"
                        />
                      </div>
                      <div class="zerenBox_text">
                        工信部工业互联网联盟审定环境行业第一个测试床
                      </div>
                    </div>
                  </div>
                  <div class="zerenBox">
                    <div>
                      <img
                        src="../assets/images/img_paiming_l.png"
                        alt=""
                        style="width: 18.485px; height: 32.75px"
                      />
                      <span class="zerenBox_title">三个唯一</span>
                      <img
                        src="../assets/images/img_paiming_l.png"
                        alt=""
                        style="
                          width: 18.485px;
                          height: 32.75px;
                          transform: rotateY(180deg);
                        "
                      />
                    </div>
                    <div style="margin-top: 15px; display: flex; width: 245px">
                      <div>
                        <img
                          src="../assets/images/zrLogo.png"
                          alt=""
                          style="width: 22px"
                        />
                      </div>
                      <div class="zerenBox_text">
                        工信部工联院审定省级国家大数据中心唯一环卫行业示范
                      </div>
                    </div>
                    <div style="margin-top: 10px; display: flex; width: 245px">
                      <div>
                        <img
                          src="../assets/images/zrLogo.png"
                          alt=""
                          style="width: 22px"
                        />
                      </div>
                      <div class="zerenBox_text">
                        工信部信通院审定环境行业唯一数据标识二级节点建设单位
                      </div>
                    </div>
                    <div style="margin-top: 10px; display: flex; width: 245px">
                      <div>
                        <img
                          src="../assets/images/zrLogo.png"
                          alt=""
                          class="object-cover"
                          style="width: 22px"
                        />
                      </div>
                      <div class="zerenBox_text">
                        中国城市环境卫生协会唯一参与指导监督建设环卫行业平台
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-row>
        </div>
      </div>
      <!-- 资质 -->
      <!-- <div class="contentall">
        <img
          src="../assets/images/zizhi.png"
          alt=""
          class="object-cover"
          style="width: 1280px"
        /> -->
      <!-- <div class="zizhi">
          <div style="width: 113px; text-align: center">
            <img src="../assets/trademark/div.png" alt="" />
            <div style="padding-top: 5px">ISO 27001</div>
          </div>
          <div style="width: 113px; text-align: center">
            <img src="../assets/trademark/div.png" alt="" />
            <div style="padding-top: 5px">ISO 27001</div>
          </div>
          <div style="width: 113px; text-align: center">
            <img src="../assets/trademark/div1.png" alt="" />
            <div style="padding-top: 5px">SOC 1 Type Ⅱ</div>
          </div>
          <div style="width: 113px; text-align: center">
            <img src="../assets/trademark/div2.png" alt="" />
            <div style="padding-top: 5px">网络安全等级保护</div>
          </div>
          <div style="width: 113px; text-align: center">
            <img src="../assets/trademark/div3.png" alt="" />
            <div style="padding-top: 5px">可信云</div>
          </div>
          <div style="width: 113px; text-align: center">
            <img src="../assets/trademark/div4.png" alt="" />
            <div style="padding-top: 5px">KISMS 认证</div>
          </div>
          <div style="width: 113px; text-align: center">
            <img src="../assets/trademark/div5.png" alt="" />
            <div style="padding-top: 5px">CISPE</div>
          </div>
          <div style="width: 113px; text-align: center">
            <img src="../assets/trademark/div6.png" alt="" />
            <div style="padding-top: 5px">SOC 鉴证审计</div>
          </div>
          <div style="width: 113px; text-align: center">
            <img src="../assets/trademark/div7.png" alt="" />
            <div style="padding-top: 5px">C5 审计</div>
          </div>
        </div> -->
      <!-- </div>  -->
      <div style="width: 100%; height: 180px" class="home-footer">
        <div
          style="
            display: flex;
            width: 1280px;
            height: 180px;
            max-width: 1280px;
            padding: 20px 0;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            gap: 20px;
            margin: 0 auto;
          "
        >
          <div
            style="
              color: #fff;

              font-size: 19px;
              font-style: normal;
              font-weight: 400;
              line-height: 22px;
            "
          >
            E平台致力于以最 “绿色节能”
            的方式，让每一位上云的客户成为全球绿色节能和降低碳排放的贡献者
          </div>
          <div
            style="background: #d7000f; color: #fff"
            class="laber-btn"
            @click="open = true"
          >
            免费试用
          </div>
        </div>
      </div>
      <!-- 服务客户 -->
      <!-- <div style="width: 100%;background-color: #F5F5F5;display: flex; justify-content: center;padding-bottom: 40px">
        <div style="max-width: 75%;width: 75%">
          <div style="font-size: 28px;text-align: center;padding: 40px 0">服务客户</div>
          <el-row :gutter="20" style="display: flex;;flex-wrap: wrap;">
            <el-col v-for="(item, index) in customerList" :key="item.id" :xs="12" :sm="8" :md="6"
              style="margin-bottom: 20px;text-align:center">
              <el-image :scroll-container="homeWrap" lazy class="customer-logo" :src="item.unitLogo">
                <div slot="error" />
              </el-image>
            </el-col>
          </el-row>
        </div>
      </div> -->

      <consult
        v-if="open"
        title="立即咨询"
        :dialogVisible="open"
        @cancel="cancle"
        :productName="name"
        productId="0"
      >
      </consult>
    </main>
    <div  v-if="showButton" class="to-top" @click="totop()">
      <img src="../assets/images/totop.png" alt="" />
    </div>
  </div>
</template>
<script>
import count from "@/api/home.js";
import { downTicket } from "@/api/home.js";
import { getConsultList } from "@/api/consult.js";
import { WebGLRenderer } from "three";
import countTo from "vue-count-to";
import {
  listProductAll,
  listSolution,
  listCase,
  listClient,
  listBanner,
  listMap,
} from "@/api";
import MapView from "./mapView/MapView.vue";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

export default {
  name: "Home",
  metaInfo: {
    title: 'Eiiplat环境产业物联网平台',
    meta: [
      { name: 'description', content: '青岛国真智慧Eiiplat环境产业物联网平台是国内首家环境产业工业互联网平台。Eiiplat平台致力于服务环境产业固废、污水、大气、噪音、辐射五大行业，其中以固废切入点，打造了智能设计、智能供应、施工管理、智能收运、智能管控 、机制管理、财务管理、OKR管理八大应用，赋能行业转型升级。利用资金流驱动废弃物的循环流动，优化过程数据提高效率，对废弃物全生命周期追溯，为客户提高生产效率和降低运营成本提供持续的解决方案。' },
      { name: 'keywords', content: '智慧环卫一网统管,无废城市,智能收运系统,车联网平台,车辆定位,餐厨、厨余垃圾智能化处理,智慧运营,厌氧智控运维平台,农村厕改长效管护监管平台,环保供应平台,环境工业互联网平台,环境产业测试床,双碳数据中心,智慧用电,安防微平台,标识解析,智能化运维平台,青岛国真智慧' },
    ],
  },
  components: {
    countTo,
    MapView,
  },
  data() {
    return {
      // 返回顶部按钮
      showButton: false,
      // 创建一个场景
      scene: null,
      // 创建一个相机
      camera: null,
      // 创建一个渲染器
      renderer: null,
      // 模型对象
      mesh: null,
      // 平面
      plane: null,
      // 点光源
      point: null,
      // step
      step: 0,
      controls: null,
      starsGeometry: null,
      bannerSourceList: [],
      video: "",
      open: false,
      name: undefined,
      typeActive: 0, //环卫
      count: {},
      productList: [],
      solutionList: [],
      consultationList: [],
      caseImg: "",
      caseText: "",
      caseList: "",
      list: [],
      customerList: [],
      homeWrap: null,
      classOption: [
        {
          direction: 2,
          step: 1,
        },
        {
          direction: 3,
          step: 1,
        },
        {
          direction: 2,
          step: 1,
        },
      ],
    };
  },
  created() {
    if (this.$route.query.ticket && this.$route.query.redirectUrl) {
      downTicket(this.$route.query.ticket).then((res) => {
        if (res.data !== null) {
          localStorage.setItem("usertoken", res.data.token);
          // localStorage.setItem("userName", res.data.userInfo.loginName);
          localStorage.setItem("userName", res.data.userInfo.userName);
          localStorage.setItem("userId", res.data.userInfo.userId);
        }
        window.location.href = this.$route.query.redirectUrl;
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll',  this.handleScroll);
  },
  computed: {},
  mounted() {
    window.addEventListener('scroll',  this.handleScroll);
    this.homeWrap = this.$refs.homeWrapRef;
    // 获取banner数据
    this.getBanner();
    this.getCount();
    // 获取解决方案数据
    this.solutionData();
    // 获取产品服务数据
    this.productData();
    this.productAllData();
    // this.initEarth();
    // 获取 案例数据
    this.caseData();
    // 获取 客户数据
    setTimeout(() => {
      this.clientData();
    }, 1000);
    // setTimeout(() => {
    //   this.$refs.seamlessScroll.reset();
    // }, 2000);
  },
  methods: {
    totop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth", // 使滚动效果平滑
      });
    },
    handleScroll() {
      this.showButton  = window.scrollY  > 200;
    },
    handleImgto(url) {
      if (url !== "") {
        window.location.href = url;
      } else {
        console.log("url为空");
      }
    },
    async initEarth() {
      // 初始化容器
      var content = this.$refs.content;
      // 创建一个场景

      this.scene = new THREE.Scene();
      this.scene.background = new THREE.Color("#fff");
      this.scene.add(new THREE.HemisphereLight("#fff", "#fff", 1));
      // 创建几何体
      var geometry = new THREE.SphereGeometry(32, 50, 50);
      // 纹理加载器 （ 此处加载贴图 ）
      // var texture = new THREE.TextureLoader().load(
      //   require("../assets/images/earth.png")
      // );
      // 几何体材质对象
      var material = new THREE.MeshLambertMaterial({
        map: null,
      });
      const result = await listMap();
      var areas = result.rows;
      // 标记点组合
      var marking = new THREE.Group();
      var gLabel = new THREE.Group();
      const list = [];
      for (var i = 0; i < areas.length; i++) {
        // 创建标记点球体
        var mark = new THREE.Mesh(
          new THREE.SphereGeometry(0.4, 50, 50),
          new THREE.MeshBasicMaterial({
            color: "#D7000F",
          })
        );
        // 获取标记点坐标
        var markPos = this.createPosition(
          areas[i].longitudeLatitude.split(",")
        );
        mark.position.set(markPos.x, markPos.y + 10, markPos.z);
        mark.name = areas[i].name;
        marking.add(mark);
        list.push(mark);
        // 此处画布不清晰
        // const canvas = document.createElement("canvas");
        // const ratio = window.devicePixelRatio || 1;
        // canvas.width = 100 * ratio; // 实际渲染像素
        // canvas.height = 30 * ratio; // 实际渲染像素
        // canvas.style.width = `100px`; // 控制显示大小
        // canvas.style.height = `30px`; // 控制显示大小
        // const ctx = canvas.getContext("2d");
        // const dpr = window.devicePixelRatio;
        // ctx.font = "16px 宋体";
        // ctx.scale(dpr, dpr);
        // ctx.fillText(areas[i].name, 0,15);

        // let texture = new THREE.Texture(canvas);
        // texture.needsUpdate = true;
        // let material = new THREE.SpriteMaterial({map:texture});
        // let text = new THREE.Sprite(material);
        // text.scale.set(0.5 * 20, 0.25 * 20, 0.75 * 10);
        // text.position.set(markPos.x, markPos.y + 15, markPos.z);
        // gLabel.add(text);
      }
      this.scene.add(marking);
      // this.scene.add(gLabel);

      // 创建网格模型对象
      this.mesh = new THREE.Mesh(geometry, material);
      //设置几何体位置
      this.mesh.position.x = 0;
      this.mesh.position.y = 10;
      this.mesh.position.z = 0;
      this.scene.add(this.mesh);
      // 添加点位
      // const renderer = new WebGLRenderer({ canvas });
      // this.createEarthMesh();
      // var pointGeo = new THREE.SphereGeometry(128,110);
      // const pointMaterial = new THREE.MeshBasicMaterial({ color: 0x00FF00 });
      // const pointMesh = new THREE.Mesh(pointGeo, pointMaterial);
      // renderer.add(pointMesh);
      // 创建点光源
      // var point = new THREE.PointLight("#FFF");
      // this.point = point;
      // this.scene.add(point);
      // const sphereSize = 10;
      // const pointLightHelper = new THREE.PointLightHelper(point, sphereSize);
      // this.scene.add(pointLightHelper);
      // 创建一个相机
      this.camera = new THREE.PerspectiveCamera(
        70,
        window.innerWidth / window.innerHeight,
        1,
        10000
      );
      this.camera.position.set(-50, 30, 50);
      this.camera.lookAt(0, 0, 0);
      // 创建渲染器
      this.renderer = new THREE.WebGLRenderer();
      this.renderer.setSize(window.innerWidth, window.innerHeight);
      this.renderer.setClearColor(0xb9d3ff, 1);
      //插入 dom 元素
      content.appendChild(this.renderer.domElement);
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.controls.enableZoom = false;
      this.controls.addEventListener("resize", this.render(), false);

      const raycaster = new THREE.Raycaster();

      // 定义点击事件
      document.addEventListener("click", (event) => {
        // 鼠标控制对象
        const mouse = new THREE.Vector2();
        // 得到鼠标相对于容器的坐标
        mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

        // 执行射线检测
        raycaster.setFromCamera(mouse, this.camera);
        // 判断指定的对象中哪些被该光线照射到了，在arrGroup中筛选
        const intersects = raycaster.intersectObjects(
          this.scene.children,
          true
        );
        // 射线涉及到的物体集合

        if (intersects.length > 0) {
          const clickObj = intersects[0];
          // 旋转网格(mesh)
          console.log("点击的当前模型：", intersects);
          if (clickObj.object.name == "black") {
            clickObj.object.rotation.x += (10 * Math.PI) / 180;
            clickObj.object.rotation.y += (10 * Math.PI) / 180;
            clickObj.object.rotation.z += (10 * Math.PI) / 180;
          }
        }
      });
    },
    toCartesian(lat, lon, radius = 6371000) {
      const phi = THREE.MathUtils.degToRad(90 - lat);
      const theta = THREE.MathUtils.degToRad(lon);

      const x = radius * Math.sin(phi) * Math.cos(theta);
      const y = radius * Math.sin(phi) * Math.sin(theta);
      const z = radius * Math.cos(phi);

      return new THREE.Vector3(x, y, z);
    },
    render() {
      this.renderer.render(this.scene, this.camera);
      // 自动旋转动画
      this.scene.rotateY(0.002);
      requestAnimationFrame(this.render);
    },

    // 坐标转换，
    createPosition(lnglat) {
      let spherical = new THREE.Spherical();
      spherical.radius = 32;
      const lng = parseFloat(lnglat[0]);
      const lat = parseFloat(lnglat[1]);
      const theta = (lng + 90) * (Math.PI / 180);
      const phi = (90 - lat) * (Math.PI / 180);
      spherical.phi = phi; // phi是方位面（水平面）内的角度，范围0~360度
      spherical.theta = theta; // theta是俯仰面（竖直面）内的角度，范围0~180度
      let position = new THREE.Vector3();
      position.setFromSpherical(spherical);
      return position;
    },

    async getBanner() {
      const res = await listBanner({ bannerPosition: "SY_BANNER" });
      res.rows.forEach((v) => {
        if (v.sourceType === "img") {
          this.bannerSourceList.push({
            url: v.bannerImg,
            type: v.sourceType,
            title: v.title,
            subTitle: v.subTitle,
            link: v.link,
          });
        } else if (v.sourceType === "video") {
          this.bannerSourceList.push({
            url: v.video,
            type: v.sourceType,
            title: v.title,
            subTitle: v.subTitle,
            remakes: v.remakes,
            link: v.link,
          });
        }
      });
    },
    // 获取客户数据
    async clientData() {
      const res = await listClient({ homepageDisplay: "1", useFlag: "1" });
      const customerList = res.rows;
      // customerList 分成三部分 ,t
      // const rowLenght = customerList.length / 3;
      const row1 = [...customerList, ...customerList];
      const row2 = [
        ...customerList.reverse(),
        ...customerList,
        ...customerList,
      ];
      const row3 = [...customerList, ...customerList];

      this.customerList = [row1, row2, row3];
      // this.initSwiper();
      // console.log(this.customerList, "xxxx");
    },
    // 获取案例数据
    async caseData() {
      const res = await listCase({ homepageDisplay: "1", useFlag: "1" });
      this.caseList = res.rows;
      this.caseImg = this.caseList[0].caseCover;
      this.caseText = this.caseList[0].caseContent;
    },
    // 获取解决方案数据
    async solutionData() {
      const res = await listSolution({ homepageDisplay: "1", useFlag: "1" });
      // 数据提取
      res.rows.forEach((v) => {
        this.solutionList.push({
          url: v.schemeCover,
          title: v.solutionTitle,
          remakes: v.schemeIntroduction,
          id: v.id,
        });
      });
    },
    // 获取产品服务数据
    async productAllData() {
      const res = await listProductAll({ homepageDisplay: "1", useFlag: "1" });
      res.data.map((item) => {
        if (!item.serviceList) return;
        // item.serviceList.reverse()
        item.serviceList.map((i) => {
          if (!i.starLabel) return;
          i.starLabel = i.starLabel.split(",");
        });
        this.list = res.data;
      });
      this.productList = res.data;
      //  this.list.map((item) => {
      //     if (!item.serviceList) return;
      //     item.serviceList.map((i) => {
      //       if (!i.starLabel) return;
      //       i.starLabel = i.starLabel.split(",");
      //     });
      //   });
    },
    // 获取平台咨询数据
    async productData() {
      const res = await getConsultList({ articleType: "PT_CONSULT", showStatus:1 });
      this.consultationList = res.rows;
    },
    tabClick(item) {
      this.caseImg = item.caseCover;
      this.caseText = item.caseContent;
    },
    //解决方案跳转
    toSolution(item) {
      this.$router.push({ path: "/Solution", query: { id: item.id } });
    },
    //产品服务-产品详情按钮跳转详情页
    handelProductDetails(item) {
      this.$router.push({ path: "/ProductService", query: { id: item.id } });
    },
    // 平台资讯跳转详情页
    goConsuleDetail(item) {
      this.$router.push({ path: "/Information", query: { id: item.id } });
    },
    // 典型案例跳转详情页
    goTypicalCase() {
      const item = this.caseList.filter((i) => {
        return i.caseCover == this.caseImg;
      })[0];
      this.$router.push({ path: "/TypicalCase", query: { id: item.id } });
    },
    // 改变通用产品分类选中
    changeTypeActive(val) {
      this.typeActive = val;
    },
    // 获取平台增效数值
    getCount() {
      count.getAllCount().then((res) => {
        if (res.code === 0) {
          this.count = res.data;
        } else {
          this.count = {
            deviceCount: 700,
            enterpriseCount: 170,
            developerCount: 360,
            effCount: 491.41,
          };
        }
      });
    },
    go() {
      this.$router.push({ path: "/DaliIndex" });
    },
    //查看更多
    handleMoreDetails(path, index) {
      this.$router.push({ path: path });
    },
    handleCaseDetails(item) {
      this.$router.push({
        path: "/solition_lower",
        query: {
          id: item.id,
        },
      });
    },
    handelConsultClick(item) {
      this.name = item.productTitle;
      this.open = true;
    },
    cancle(data) {
      this.open = data;
    },
    // 直播查看回放列表
    allLiveReplay() {
      this.$router.push({ path: "/replay" });
    },
    // 回放详情
    playbackDetail(name) {
      this.$router.push({ path: "/replay", query: { id: name } });
    },
    livePreview() {
      // 直播预告
      this.$router.push({ path: "/replay", query: { path: "/previewDetail" } });
    },
  },
};
</script>
<style lang="scss">
.home-footer {
  background-image: url("../assets/images/bg-footer.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}
.to-top {
  cursor: pointer;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  border-radius: 5px;
  // border: 1px solid #ccc;
  position: fixed;
  z-index: 9999999;
  bottom: 100px;
  right: 100px;
  background-color: #fff;
  box-shadow: 0px 0px 8px 2px #ccc;
  img {
    width: 50%;
    height: 50%;
  }
}
.ptImage-left {
  margin: 40px 20px 20px 40px;
  &:nth-of-type(2) {
    margin: 0 20px 40px 40px !important;
  }
}
.ptImage_right {
  margin: 40px 40px 20px 0;
  &:nth-of-type(4) {
    margin: 0 40px 20px 0 !important;
  }
  &:nth-of-type(5) {
    margin: 0 40px 20px 0 !important;
  }
}
.el-image__inner {
  object-fit: cover;
}
.el-carousel__container,
.el-carousel,
.el-image {
  height: 100% !important;
}
.el-carousel__button {
  display: block;
  opacity: 0.48;
  width: 40px;
  height: 6px;
  background-color: #fff;
  border: none;
  outline: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.el-carousel__indicator.is-active button {
  background-color: #d7000f !important;
}
.grid-hero {
  display: grid;
  grid-template-areas: "hero";

  > * {
    box-sizing: border-box;
    grid-area: hero;
  }

  > img {
    object-fit: cover;
    height: 100%;
    width: 100%;
    //z-index: -1;
    overflow: hidden;
  }
}

#container {
  height: 100%;
  overflow: hidden;
}

.banner_carousel {
  .el-carousel__indicators--horizontal {
    bottom: 130px !important;
  }
}
</style>
<style lang="scss" scoped>
.contentall {
  width: 1280px;
  margin: 0 auto;
}
.jxfa {
  display: grid;

  grid-template-areas: "hero";
  box-sizing: border-box;
  //相当于 align-items justify-items 的缩写
  place-items: center;
  > * {
    box-sizing: border-box;
    grid-area: hero;
  }
  > img {
    object-fit: cover;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }
  > div {
    z-index: 2;
  }
}

.zizhi {
  width: 1280px;
  padding: 20px 0;
  margin: 0 auto;
  display: flex;
  background: linear-gradient(0deg, white 0%, #fffbfb 100%);
  border: 2px white solid;
  justify-content: space-between;
  align-items: center;
  display: inline-flex;
}

.normal {
  width: 100%;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}

.w-full-1440 {
  width: 100%;
  // max-width: 1440px;
  margin: 0 auto;
}

.absolute-center {
  position: absolute;
  //top: 690px;
  //left: 322px;
  left: 50%;
  //top: 50%;
  transform: translate(-50%, -100%);
}
.item-boxs {
  width: 200px;
  height: 80px;
  margin-right: 12px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.1), -8px -8px 20px 0px #fff,
    0px 4px 20px 0px rgba(255, 255, 255, 0.5) inset;
}
.scrollImage {
  width: 200px;
  height: 80px;
  gap: 0px;
}

.swiper-wrapper {
  background: #ffffff !important;
}

.swiper-slide .el-image {
  background: #ffffff;
  width: 200px !important;
  height: 80px !important;
  border-radius: 8px 0px 0px 0px;
  // padding: 20px 0px 0px 0px;
  gap: 0px;
  opacity: 0px;
  box-shadow: 0px 4px 20px 0px #ffffff80 inset;
}

.zeren {
  color: #d7000f;
  font-family: FontquanXinYiGuanHeiTi;
  font-size: 37.625px;
  font-style: normal;
  font-weight: 400;
  line-height: 46px;
  margin-bottom: 17px;
  /* 122.259% */
}

.zerenContent {
  color: #666666;
  font-family: FontquanXinYiGuanHeiTi;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  width: 783px;
  line-height: 34px;
  margin-bottom: 54px;
  /* 212.5% */
}

.zerenBox {
  margin-right: 16px;
  width: 289px;
  height: 240px;
  gap: 15px;
  background-image: url("../assets/images/zrbg.png");
  background-size: 100%;
  background-repeat: no-repeat;
  padding: 20px;
  > div:first-of-type {
    text-align: center;
  }
  .zerenBox_title {
    display: inline-block;
    margin: 0 15px;
    color: #d7000f;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 25px;
    text-align: center;
    /* 138.889% */
  }

  .zerenBox_text {
    color: #333333;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    /* 157.143% */
  }
}

.laber-btn {
  height: 34px;
  width: 80px;
  line-height: 34px;
  margin-right: 10px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
}
.star-label {
  min-height: 161px;
  /* background: #fff; */
  /* margin: 25px 0; */
  padding: 32px 20px;
  cursor: pointer;
  -webkit-transition: 0.5s all;
  transition: 0.5s all;
  // background-image: url(/static/img/bg_chanpin.24dae3b.png);
  // background-repeat: no-repeat;
  // background-size: 100%;
  // background-position-y: -1px;
  background: linear-gradient(
      0deg,
      var(--Color-2, #fff) 0%,
      var(--Color-2, #fff) 100%
    ),
    url(<path-to-image>) lightgray 50% / cover no-repeat;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.03);
  display: flex;
  padding: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 14px;
  flex: 1 0 0;
  align-self: stretch;
  &:hover {
    box-shadow: 13px 13px 23px rgba(0, 0, 0, 0.25);
  }

  &:hover .label-title {
    color: #e50009;
  }

  .laber-btn {
    height: 34px;
    width: 80px;
    line-height: 34px;
    margin-right: 10px;
    text-align: center;
    font-size: 14px;
  }
}

.label-title {
  font-size: 16px;
  font-weight: 600;
  color: #131415;
  // margin-bottom: 12px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  // display: flex;
  height: 25px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
}

.label-desc {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: rgba(19, 20, 21, 0.7);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  height: 16px;
  width: 100%;
}

.general-label {
  min-height: 75px;
  // margin: 30px 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
  justify-content: center;
  cursor: pointer;
  transition: 0.5s all;

  &:hover .label-title {
    color: #e50009;
  }
}

.ptImage_other {
  overflow: hidden;
  cursor: pointer;

  &:hover .ptImage_other-label > img {
    transform: scale(1.2);
  }
}

.ptHover {
  cursor: pointer;

  .ptImage > img {
    transition: all 0.6s;
  }

  .ptImage {
    // overflow: hidden;
    cursor: pointer;
  }

  .ptTitle {
    font-size: 18px;
    font-weight: 400;
    line-height: 25px;
    letter-spacing: 0em;
    text-align: left;
    color: #ffffff;
  }

  .ptContent {
    color: #ffffffcc;

    font-size: 16px;
    font-weight: 400;
    line-height: 25px;
    letter-spacing: 0em;
    text-align: left;
    margin: 10px 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .ptTime {
    color: #ffffffcc;

    font-size: 12px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
  }

  &:hover .ptTitle {
    color: #e50009;
  }

  &:hover .ptContent {
    color: #e50009;
  }

  &:hover .ptImage > img {
    transform: scale(1.2);
  }
}

.solution {
  height: 2.61rem;
  /* height: 261px; */

  .solution-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #252525;
    opacity: 0.9;
    transition: 0.5s all;
    z-index: 1;
  }

  .el-image {
    width: 100%;
    height: 100%;
  }

  .solution-card {
    position: absolute;
    width: 80%;
    cursor: pointer;
    z-index: 99;
  }

  &:hover .solution-mask {
    opacity: 0.3;
    border-bottom: 3px solid #e50009;
  }
}

.customer-logo {
  transition: all 0.5s;
  width: 1.84rem;
  height: 0.9rem;
  max-width: 100%;
}

.customer-logo:hover {
  transform: scale(1.2);
}

.title {
  font-size: 0.32rem;
  padding: 0.6rem 0;
  text-align: center;
}

.bannerText {
  position: absolute;
  top: 268px;
  left: 50%;
  margin-left: -640px;
  z-index: 100;
  width: 1280px;
  cursor: pointer;
  height: 228px;

  .title {
    font-size: 40px;
    font-weight: 600;
    line-height: 56px;
    padding-bottom: 32px;
    letter-spacing: 0em;
    text-align: left;
    color: #333;
  }

  .text {
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    letter-spacing: 0em;
    text-align: left;
    color: #333;
  }

  .button {
    width: 128px;
    height: 44px;
    background: #d7000f;
    color: #ffffff;
    border: none;
    margin-top: 50px;
    // border-radius: 5px;
    padding: 11px 35px;
    font-size: 14px;
    display: block;
  }
}

.bannerText_other {
  background: #00000066;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
  padding-top: 60px;
  padding-left: 90px;
  transition: all 1s;
  &:hover {
    background: none;
  }

  .title {
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: 0em;
    text-align: left;
    color: #ffffff;
    margin-top: 100px;
  }

  .text {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #ffffff;
  }

  .button {
    width: 128px;
    height: 44px;
    background: #d7000f;
    color: #ffffff;
    border: none;
    margin-top: 50px;
  }
}

.ptzengxiao {
  position: absolute;
  top: 799px;
  // left: 322px;
  left: 50%;
  // top: 50%;
  transform: translate(-50%, -100%);
  z-index: 1000;
  width: 1280px !important;
  border: 2px solid rgba(255, 255, 255, 0.6);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.6) 0%,
    rgba(255, 255, 255, 0.8) 100%
  );
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.04),
    0px 16px 24px 0px rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(8px);
  height: 110px;

  .number {
    span {
      color: var(---333, #333);
      font-family: Oswald;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }
}

.box {
  padding: 0 1rem;
  display: flex;
  justify-content: center;

  .area {
    // margin-top: 5px;

    width: calc(25% - 1px);
    text-align: center;
    float: left;
    &:first-of-type {
      background-image: url("../../static/img/display-img/show_new/bg_zxsy.png");
      background-repeat: no-repeat;
    }
    &:nth-of-type(2) {
      background-image: url("../../static/img/display-img/show_new/bg_jrsb.png");
      background-repeat: no-repeat;
    }

    &:nth-of-type(3) {
      background-image: url("../../static/img/display-img/show_new/bg_fwqy.png");
      background-repeat: no-repeat;
    }
    &:last-of-type {
      background-image: url("../../static/img/display-img/show_new/bg_kfz.png");
      background-repeat: no-repeat;
    }
    .imgs {
      position: relative;
      left: 60px;
    }
    .number {
      margin-top: 6px;

      span {
        //font-size: 0.48rem;
        font-weight: 700;
        // margin-right: 50px;
        color: #333333;
      }
    }

    .text {
      color: #666666;
    }

    .image {
      height: 0.6rem;

      img {
        margin-bottom: -0.05rem;
        margin-right: 0.15rem;
        //width: 0.48rem;
      }

      span {
        color: #1a1a1a !important;
        margin-bottom: 20px;
      }
    }
  }
}

.qyigol_img_cover {
  display: flex;
  padding: 20px 80px 20px 20px;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  z-index: 100;
}
.pointer {
  cursor: pointer;
}
.live-label {
  color: #000;
  .liveTitle {
    color: #333333;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    text-align: left;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    margin-bottom: 10px;
  }
  .liveTime {
    color: #666666;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
  }
}
.liveyugaotitle {
  background: #fff;
  padding: 16px 20px;
  // background: linear-gradient(to top, rgba(0, 0, 0, 0.86), rgba(187, 179, 179, 0.03));
}
.jianjie {
  font-size: 16px;
  font-weight: 400;

  color: #666666;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  // height: 20px;
  line-height: 20px;
  margin-top: 10px;
}
.huifang {
  font-size: 14px;
  position: absolute;
  top: 2px;
  left: 2px;
  color: #fff;
  padding: 2px 8px;
  background: #d7000fcc;
  font-weight: 400;
  width: 44px;
  height: 24px;
  border-radius: 0px 0px 8px 0px;
  opacity: 0px;
}
.livePreview {
  font-size: 28px;
  font-weight: 400;
  color: #fff;
  height: 39px;
  line-height: 39px;
}
.livePreview::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 14px;
  margin-right: 5px;
  background: #d7000f;
}
.liveimg {
  width: 234px;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
  border: 2px solid #fff;
  box-shadow: -8px -8px 20px 0px #ffffff;
  box-shadow: 8px 8px 20px 0px #3763aa1a;
}
.live-box {
  width: 100%;
  display: flex;
  justify-content: center;
  // padding-bottom: 40px;
  background-image: url("../assets/images/livebackground/backimg.png");
  background-repeat: no-repeat;
  background-size: 100%;
  // object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue